// import { useState, useEffect, useMemo , useRef} from 'react';
// import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, FormControlLabel, Checkbox, useTheme, Grid, Divider, Snackbar, Alert } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import DropdownProductCode from './DropdownProductCode';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useAuth } from '../../../context/AuthContext';
// import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';
// import Dropdown from '../../../components/Dropdown';

// const ProductDetails = ({ initialData, onNext, clientData, challanIds, connectionString, mode, creditNoteExists, onRowsChange }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     console.log("ididi", initialData)
//     const state = clientData?.details?.['State'] || '';
//     const compState = selectedCompany?.State || '';
//     console.log('challanIds:', challanIds);
//     console.log(`state: ${state} || compState: ${compState}`);
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down('md'));
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     const [isInitialized, setIsInitialized] = useState(false);

//     const [rows, setRows] = useState([]);
//     const [nextSrNo, setNextSrNo] = useState(1);
//     const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, batchNo: '', expDate: '', serialNo: '', amount: '', taxAmount: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null });
//     const [totals, setTotals] = useState({ basic: 0, discount: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, total: 0 });
//     const [errors, setErrors] = useState({});
//     const [editIndex, setEditIndex] = useState(null);
//     const [allProducts, setAllProducts] = useState([]);
//     const [unitOptions, setUnitOptions] = useState([]);
//     const [colorMap, setColorMap] = useState({});
//     const [sizeMap, setSizeMap] = useState({});
//     // const [originalEditQty, setOriginalEditQty] = useState(null);
//     const [isEditingMode, setIsEditingMode] = useState(false);

//     const [gsts, setGsts] = useState([]);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });




//     const [tcsEnabled, setTcsEnabled] = useState(false);
//     const [tcsPercent, setTcsPercent] = useState(0);
//     const [tcsAmount, setTcsAmount] = useState(0);


//     useEffect(() => {
//         if (!tcsEnabled) {
//             setTcsAmount(0);
//             return;
//         }

//         const baseAmount =
//             Number(totals.basic || 0) +
//             Number(totals.cgst || 0) +
//             Number(totals.sgst || 0) +
//             Number(totals.igst || 0);

//         const tcs = (baseAmount * Number(tcsPercent || 0)) / 100;

//         setTcsAmount(tcs);
//     }, [tcsEnabled, tcsPercent, totals]);


//     // Track if component has finished initializing
//     const hasInitializedRef = useRef(false);

//     // Notify parent when rows change â€” but ONLY after initialization is done
//     useEffect(() => {
//         if (!hasInitializedRef.current) return; // Don't fire on first empty render
//         if (onRowsChange) {
//             onRowsChange(rows);
//         }
//     }, [rows]);

//     // Reset isInitialized when coming back with data but rows are empty
//     useEffect(() => {
//         if (initialData?.tableData?.length && rows.length === 0 && hasInitializedRef.current) {
//             setIsInitialized(false);
//         }
//     }, [initialData?.tableData]);

//     // For add mode â€” no initialData, so mark as initialized immediately
//     useEffect(() => {
//         if (!initialData?.tableData?.length) {
//             hasInitializedRef.current = true;
//         }
//     }, []);



//     useEffect(() => {
//         if (!initialData?.summary) return;

//         const s = initialData.summary;

//         setTcsEnabled(s.tcsApplied === 1);
//         setTcsPercent(s.tcsPercent || 0);
//         setTcsAmount(s.tcsAmount || 0);
//     }, [initialData]);


//     const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

//     const API_BASE = `${connectionString}/api`;

//     const transformGSTs = data => Array.isArray(data) ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode })) : [];
//     const Hlp_Fn_GST = async () => {
//         try {
//             const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
//             console.log(data)
//             setGsts(transformGSTs(data));
//         } catch (e) {
//             console.error('GST lookup failed', e);
//             setSnackbar({ open: true, message: 'GST lookup failed.', severity: 'error' });
//             setGsts([]);
//         }
//     };

//     useEffect(() => {
//         Hlp_Fn_GST();
//     }, []);


//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, { params: { companyId } });
//                 setUnitOptions(unitsRes.data); // Expecting [{ UnitId: 43, unit: "NOS" }, ...]
//                 const [cRes, sRes] = await Promise.all([axios.get(`${connectionString}/api/colormaster`), axios.get(`${connectionString}/api/sizemaster`)]);
//                 const cm = {}, sm = {};
//                 cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
//                 sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
//                 setColorMap(cm);
//                 setSizeMap(sm);
//             } catch (error) {
//                 console.error('Error fetching product or unit data:', error);
//             }
//         };

//         fetchData();
//         loadAllProducts();
//     }, []);

//     // In onNext callback or when popup closes
//     // Pass a callback to ProductMaster to refresh units

//     const handleProductAdded = async () => {
//         // Reload units when product is added
//         try {
//             const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, {
//                 params: { companyId }
//             });
//             setUnitOptions(unitsRes.data);

//             // Also reload products
//             await loadAllProducts();
//         } catch (error) {
//             console.error('Error refreshing data:', error);
//         }
//     };

//     const loadAllProducts = async () => {
//         try {
//             const res = await axios.get(`${connectionString}/api/productdata/retrive`, { params: { companyId } });
//             setAllProducts(res.data || []);
//         } catch (e) {
//             console.error('Error fetching products:', e);
//         }
//     };

//     const getTaxPercent = (value) => {
//         if (!value) return 0;

//         // remove % sign
//         const cleaned = value.replace('%', '').trim();

//         const parsed = parseFloat(cleaned);

//         return isNaN(parsed) ? 0 : parsed;
//     };

//     useEffect(() => {
//         if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !unitOptions.length || !allProducts.length) {
//             return;
//         }

//         const initialRows = initialData.tableData.map((r, index) => {
//             const qty = mode === 'ref' ? Number(r.dispQty ?? r.qty) || 0 : Number(r.qty) || 0;
//             const rate = Number(r.rate) || 0;
//             const disc = Number(r.disc) || 0;
//             const taxableAmt = qty * rate * (1 - disc / 100);
//             let taxId = r.taxId || r.TaxId || null;

//             const product = allProducts.find(p => p.Id === r.productId || p.itemCode === r.productCode);

//             //  GST lookup
//             const matchedGST = gsts.find(g => String(g.Id) === String(taxId));

//             //  final %
//             let tax = matchedGST
//                 ? getTaxPercent(matchedGST.value)
//                 : Number(r.tax) || (Number(r.CGST) + Number(r.SGST)) || Number(r.IGST) || 0;



//             let taxAmount = taxableAmt * (tax / 100);
//             let cgst = '0.00', sgst = '0.00', igst = '0.00';
//             let cgstAmt = '0.00', sgstAmt = '0.00', igstAmt = '0.00';

//             const matchedUnit =
//                 unitOptions.find(u => String(u.UnitId) === String(r.UnitId)) ||
//                 unitOptions.find(u => u.unit?.toLowerCase() === String(r.unit).toLowerCase()) ||
//                 (product ? unitOptions.find(u => String(u.UnitId) === String(product.UnitId) || u.unit?.toLowerCase() === String(product.Unit?.toLowerCase())) : null);

//             if (product) {
//                 tax = tax;       //  backend value
//                 taxId = r.taxId || r.TaxId || null;        //  backend value
//                 taxAmount = taxableAmt * (tax / 100);
//                 cgst = state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00';
//                 sgst = state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00';
//                 igst = state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00';
//                 cgstAmt = state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00';
//                 sgstAmt = state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00';
//                 igstAmt = state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00';
//             } else {
//                 taxAmount = taxableAmt * (tax / 100);
//                 cgst = String(r.CGST || (state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2) : 0)).toFixed(2);
//                 sgst = String(r.SGST || (state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2) : 0)).toFixed(2);
//                 igst = String(r.IGST || (state?.toLowerCase() !== compState?.toLowerCase() ? tax : 0)).toFixed(2);
//                 cgstAmt = Number(r.CGSTAmt || (state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2) : 0)).toFixed(2);
//                 sgstAmt = Number(r.SGSTAmt || (state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2) : 0)).toFixed(2);
//                 igstAmt = Number(r.IGSTAmt || (state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount : 0)).toFixed(2);
//             }

//             return {
//                 ...r,
//                 productId: r.productId || r.Id || r.id || '',
//                 UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId || ''),
//                 unit: matchedUnit ? matchedUnit.unit : (product?.Unit || ''),
//                 qty,
//                 rate,
//                 dispQty: Number(r.dispQty) || 0,
//                 disc,
//                 tax,
//                 TaxableAmt: Number(r.TaxableAmt) || taxableAmt.toFixed(2),
//                 taxAmount: Number(r.taxAmount) || taxAmount.toFixed(2),
//                 amount: Number(r.TaxableAmt) || taxableAmt.toFixed(2),
//                 CGST: cgst,
//                 SGST: sgst,
//                 IGST: igst,
//                 CGSTAmt: cgstAmt,
//                 SGSTAmt: sgstAmt,
//                 IGSTAmt: igstAmt,
//                 UTGST: String(r.UTGST || '0.00'),
//                 GSTCess: String(r.GSTCess || '0.00'),
//                 TaxId: taxId,
//                 srNo: initialData.tableData.length - index,
//                 challanDtsID: r.challanDtsID || null,
//                 challanID: r.challanID || null,
//                 soId: r.soId || null,
//                 soDtsID: r.soDtsID || null
//             };
//         });

//         setRows(initialRows);
//         setNextSrNo(initialRows.length + 1);
//         setIsInitialized(true);
//         hasInitializedRef.current = true; // â† for lifting rows state up 
//     }, [initialData?.tableData, unitOptions, allProducts, state, compState, isInitialized]);

//     useEffect(() => {
//         const qty = Number(current.qty) || 0;
//         const rate = Number(current.rate) || 0;
//         const disc = Number(current.disc) || 0;
//         const tax = Number(current.tax) || 0;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);
//         setCurrent(prev => ({
//             ...prev,
//             TaxableAmt: taxableAmt.toFixed(2),
//             amount: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//             CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00'
//         }));
//     }, [current.qty, current.rate, current.disc, current.tax, state, compState]);

//     useEffect(() => {
//         const n = v => Number(v || 0);
//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//         let basicAmountSum = 0;
//         let discountTotal = 0;
//         let cgstTotal = 0;
//         let sgstTotal = 0;
//         let igstTotal = 0;

//         rows.forEach(r => {
//             const qty = n(r.qty);
//             const rate = n(r.rate);
//             const gross = qty * rate;
//             const taxable = n(r.amount || r.TaxableAmt);
//             const discAmtRow = n(r.DiscAmt) || Math.max(0, gross - taxable);
//             const taxPct = n(r.tax);

//             const cgstAmtRow = (r.CGSTAmt != null && r.CGSTAmt !== '') ? n(r.CGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
//             const sgstAmtRow = (r.SGSTAmt != null && r.SGSTAmt !== '') ? n(r.SGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
//             const igstAmtRow = (r.IGSTAmt != null && r.IGSTAmt !== '') ? n(r.IGSTAmt) : (isSameState ? 0 : taxable * (taxPct / 100));

//             basicAmountSum += taxable;
//             discountTotal += discAmtRow;
//             cgstTotal += cgstAmtRow;
//             sgstTotal += sgstAmtRow;
//             igstTotal += igstAmtRow;
//         });

//         const totalTax = cgstTotal + sgstTotal + igstTotal;

//         // âœ… Subtotal
//         const subTotal = basicAmountSum + totalTax;

//         // âœ… TCS on (Basic + GST)
//         const tcs = tcsEnabled
//             ? (subTotal * Number(tcsPercent || 0)) / 100
//             : 0;

//         // âœ… FINAL BEFORE ROUND OFF
//         const finalAmount = subTotal + tcs;

//         // const roundedFinal = Math.ceil(finalAmount);
//         // const roundOff = Number((roundedFinal - finalAmount).toFixed(2));
//         const decimalPart = finalAmount - Math.floor(finalAmount);

//         const roundedFinal =
//             decimalPart >= 0.5
//                 ? Math.ceil(finalAmount)
//                 : Math.floor(finalAmount);

//         const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

//         setTotals({
//             basic: basicAmountSum.toFixed(2),
//             discount: discountTotal.toFixed(2),
//             cgst: cgstTotal.toFixed(2),
//             sgst: sgstTotal.toFixed(2),
//             igst: igstTotal.toFixed(2),
//             roundOff: roundOff.toFixed(2),
//             total: roundedFinal.toFixed(2)
//         });
//     }, [rows, state, compState, tcsEnabled, tcsPercent]);




//     // const handleChange = field => e => {
//     //     if (field === 'UnitId') {
//     //         const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
//     //         setCurrent(prev => ({
//     //             ...prev,
//     //             UnitId: e.target.value,
//     //             unit: selectedUnit ? selectedUnit.unit : ''
//     //         }));
//     //     } else {
//     //         setCurrent(prev => ({ ...prev, [field]: e.target.value }));
//     //     }
//     // };

//     // const handleChange = field => e => {
//     //     if (field === 'UnitId') {
//     //         const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
//     //         setCurrent(prev => ({
//     //             ...prev,
//     //             UnitId: e.target.value,
//     //             unit: selectedUnit ? selectedUnit.unit : ''
//     //         }));
//     //     } else if (field === 'qty') {
//     //         let value = e.target.value;
//     //         let numeric = Number(value) || 0;

//     //         // When editing an existing row, do NOT allow qty > originalEditQty
//     //         if (editIndex != null && originalEditQty != null && numeric > originalEditQty) {
//     //             numeric = originalEditQty;
//     //         }

//     //         setCurrent(prev => ({
//     //             ...prev,
//     //             qty: numeric
//     //         }));
//     //     } else {
//     //         setCurrent(prev => ({ ...prev, [field]: e.target.value }));
//     //     }
//     // };

//     const handleChange = field => e => {
//         if (field === 'UnitId') {
//             const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
//             setCurrent(prev => ({
//                 ...prev,
//                 UnitId: e.target.value,
//                 unit: selectedUnit ? selectedUnit.unit : ''
//             }));
//         } else {
//             setCurrent(prev => ({
//                 ...prev,
//                 [field]: e.target.value
//             }));
//         }
//     };


//     const handleSelect = product => {
//         const matchedUnit = unitOptions.find(opt => {
//             if (product.UnitId && opt.UnitId === product.UnitId) return true;
//             if (product.Unit && opt.unit?.toLowerCase() === product.Unit.toLowerCase()) return true;
//             if (product.unit && opt.unit?.toLowerCase() === product.unit.toLowerCase()) return true;
//             return false;
//         });
//         const qty = 1;
//         const rate = Number(product.saleRate) || 0;
//         const disc = Number(product.saleDiscount) || 0;
//         const tax = parseFloat(product.GST) || 0;
//         const taxId = product.TaxId || null;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);
//         setCurrent({
//             Id: product.Id?.toString() || '',
//             productCode: product.itemCode || '',
//             description: product.description || '',
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
//             unit: matchedUnit ? matchedUnit.unit : '',
//             qty,
//             rate,
//             disc,
//             tax,
//             batchNo: '',
//             expDate: '',
//             serialNo: '',
//             amount: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             remark: '',
//             TaxId: taxId,
//             CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//             UTGST: '0.00',
//             GSTCess: '0.00',
//             CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
//             TaxableAmt: taxableAmt.toFixed(2),
//             challanDtsID: null,
//             challanID: null,
//             soId: null,
//             soDtsID: null
//         });
//         // setEditIndex(null);
//         setErrors({});
//     };

//     // const isChallanLocked = useMemo(() => {
//     //     if (!Array.isArray(initialData?.tableData)) return false;

//     //     return initialData.tableData.some(
//     //         row => row?.challanID != null || row?.challanDtsID != null
//     //     );
//     // }, [initialData?.tableData]);

//     const isChallanLocked = useMemo(() => {
//         if (mode === 'ref') return true;
//         if (creditNoteExists) return true;

//         if (!Array.isArray(rows)) return false;

//         return rows.some(
//             r => r?.challanID != null || r?.challanDtsID != null
//         );
//     }, [rows, mode, creditNoteExists]);

//     const addProduct = () => {

//         if (isChallanLocked) return;

//         const errs = {};
//         const messages = new Set();
//         const requiredFields = ['productCode', 'description', 'UnitId', 'qty', 'rate', 'tax'];

//         requiredFields.forEach(field => {
//             if (!current[field] && current[field] !== 0) {
//                 errs[field] = 'Required';
//                 messages.add('All fields are required.');
//             }
//         });

//         if (!current.qty || Number(current.qty) <= 0) {
//             errs.qty = 'Must be > 0';
//             messages.add('Qty must be greater than 0');
//         }

//         if (!current.rate || Number(current.rate) <= 0) {
//             errs.rate = 'Rate must be greater than 0';
//             messages.add('Rate must be greater than 0');
//         }

//         if (current.disc < 0) {
//             errs.disc = 'Cannot be negative';
//             messages.add('Discount cannot be negative');
//         }

//         if (current.disc > 100) {
//             errs.disc = 'Cannot be more than 100';
//             messages.add('Discount cannot be more than 100');
//         }

//         if (messages.size > 0) {
//             errs.global = Array.from(messages);
//             setErrors(errs);
//             return;
//         }

//         const safeDisc =
//             current.disc === '' || current.disc == null
//                 ? 0
//                 : Number(current.disc);

//         const qty = Number(current.qty) || 0;
//         const rate = Number(current.rate) || 0;
//         // const disc = Number(current.disc) || 0;
//         const disc = safeDisc || 0;
//         const tax = Number(current.tax) || 0;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);

//         const row = {
//             ...current,
//             productId: current.Id,
//             qty,
//             rate,
//             disc,
//             tax,
//             remark: current.remark || '',
//             TaxableAmt: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             amount: taxableAmt.toFixed(2),
//             CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//             CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
//             UTGST: current.UTGST,
//             GSTCess: current.GSTCess,
//             TaxId: current.TaxId,
//             srNo: editIndex != null ? rows[editIndex].srNo : nextSrNo,
//             challanDtsID: editIndex != null ? rows[editIndex].challanDtsID : null,
//             challanID: editIndex != null ? rows[editIndex].challanID : null,
//             soId: editIndex != null ? rows[editIndex].soId : null,
//             soDtsID: editIndex != null ? rows[editIndex].soDtsID : null
//         };

//         const existingRowIndex = rows.findIndex(
//             (r, i) => r.productCode === current.productCode && i !== editIndex
//         );

//         // if (existingRowIndex !== -1 && editIndex == null) {
//         //     setRows(prev =>
//         //         prev.map((r, i) => {
//         //             if (i === existingRowIndex) {
//         //                 const newQty = Number(r.qty) + qty;
//         //                 const newTaxableAmt = newQty * rate * (1 - disc / 100);
//         //                 const newTaxAmount = newTaxableAmt * (tax / 100);
//         //                 return {
//         //                     ...r,
//         //                     qty: newQty,
//         //                     rate,
//         //                     disc,
//         //                     tax,
//         //                     remark: current.remark || r.remark,
//         //                     TaxableAmt: newTaxableAmt.toFixed(2),
//         //                     taxAmount: newTaxAmount.toFixed(2),
//         //                     amount: newTaxableAmt.toFixed(2),
//         //                     CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//         //                     SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//         //                     IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//         //                     CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
//         //                     SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
//         //                     IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? newTaxAmount.toFixed(2) : '0.00',
//         //                     UTGST: current.UTGST,
//         //                     GSTCess: current.GSTCess,
//         //                     TaxId: current.TaxId,
//         //                     challanDtsID: r.challanDtsID,
//         //                     challanID: r.challanID,
//         //                     soId: r.soId,
//         //                     soDtsID: r.soDtsID
//         //                 };
//         //             }
//         //             return r;
//         //         })
//         //     );
//         // } else {
//         //     if (editIndex != null) {
//         //         setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
//         //     } else {
//         //         setRows(prev => [row, ...prev]);
//         //         setNextSrNo(prev => prev + 1);
//         //     }
//         // }

//         if (editIndex != null) {
//             setRows(prev => prev.map((r, i) => i === editIndex ? { ...row, srNo: rows[editIndex].srNo } : r));
//         } else {
//             setRows(prev => [row, ...prev]);
//             setNextSrNo(prev => prev + 1);
//         }

//         setIsEditingMode(false);
//         setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, refNo: '', refDate: '', refQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', gOth10: '0.00' });
//         setErrors({});
//         setEditIndex(null);
//         // setOriginalEditQty(null);
//     };

//     const editRow = idx => {
//         if (isChallanLocked) return;
//         const row = rows[idx];
//         const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(row.UnitId)) ||
//             unitOptions.find(u => String(u.UnitId) === String(row.unit)) ||
//             unitOptions.find(u => u.unit?.toLowerCase() === String(row.unit).toLowerCase());

//         setCurrent({
//             ...row,
//             Id: row.productId,
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : row.UnitId || '',
//             unit: matchedUnit ? matchedUnit.unit : row.unit || '',
//             CGST: String(row.CGST || '0.00'),
//             SGST: String(row.SGST || '0.00'),
//             IGST: String(row.IGST || '0.00'),
//             CGSTAmt: String(row.CGSTAmt || '0.00'),
//             SGSTAmt: String(row.SGSTAmt || '0.00'),
//             IGSTAmt: String(row.IGSTAmt || '0.00'),
//             UTGST: String(row.UTGST || '0.00'),
//             GSTCess: String(row.GSTCess || '0.00'),
//             TaxableAmt: String(row.TaxableAmt || '0.00'),
//             taxAmount: String(row.taxAmount || '0.00'),
//             amount: String(row.amount || '0.00'),
//             TaxId: row.TaxId || null,
//             challanDtsID: row.challanDtsID || null,
//             challanID: row.challanID || null,
//             soId: row.soId || null,
//             soDtsID: row.soDtsID || null
//         });
//         setEditIndex(idx);
//         // setOriginalEditQty(Number(row.qty) || 0);
//         setIsEditingMode(true);
//     };

//     const deleteRow = idx => {
//         setRows(prev => prev.filter((_, i) => i !== idx));
//         if (idx === editIndex) {
//             setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, refNo: '', refDate: '', refQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', gOth10: '0.00' });
//             setEditIndex(null);
//             setErrors({});
//             // setOriginalEditQty(null);
//             setIsEditingMode(false);
//         }
//     };

//     const handleNext = () => {
//         if (rows.length === 0) {
//             setErrors({ global: 'Add at least one product' });
//             return;
//         }

//         if (tcsEnabled) {
//             const percent = Number(tcsPercent);

//             if (!tcsPercent || percent <= 0) {
//                 setErrors({ global: 'TCS % is required' });
//                 return;
//             }

//             if (isNaN(percent)) {
//                 setErrors({ global: 'Invalid TCS %' });
//                 return;
//             }

//             if (percent > 100) {
//                 setErrors({ global: 'TCS % cannot exceed 100' });
//                 return;
//             }

//             // if (!/^\d+(\.\d{1,2})?$/.test(tcsPercent)) {
//             //     setErrors({ global: 'TCS % allows max 2 decimal places' });
//             //     return;
//             // }
//         }

//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//         const payloadRows = rows.map(r => {
//             const qty = Number(r.qty) || 0;
//             const rate = Number(r.rate) || 0;
//             const gross = qty * rate;
//             const taxable = Number(r.amount || r.TaxableAmt) || 0;
//             const discAmt = Number(r.DiscAmt) || Math.max(0, gross - taxable);
//             const taxPct = Number(r.tax) || 0;
//             const taxAmt = Number(r.taxAmount) || (taxable * (taxPct / 100));

//             const cgstAmt = (r.CGSTAmt != null && r.CGSTAmt !== '') ? Number(r.CGSTAmt) : (isSameState ? taxAmt / 2 : 0);
//             const sgstAmt = (r.SGSTAmt != null && r.SGSTAmt !== '') ? Number(r.SGSTAmt) : (isSameState ? taxAmt / 2 : 0);
//             const igstAmt = (r.IGSTAmt != null && r.IGSTAmt !== '') ? Number(r.IGSTAmt) : (isSameState ? 0 : taxAmt);

//             return {
//                 ...r,
//                 productId: r.productId,
//                 productCode: r.productCode,
//                 description: r.description,
//                 unit: r.unit,
//                 UnitId: Number(r.UnitId) || null,
//                 qty: mode === 'ref' ? Number(r.dispQty ?? r.qty) || 0 : Number(r.qty) || 0,
//                 rate,
//                 disc: Number(r.disc) || 0,
//                 tax: taxPct,
//                 batchNo: r.batchNo || '',
//                 expDate: r.expDate || null,
//                 serialNo: r.serialNo || '',
//                 remark: r.remark || '',
//                 gross: Number(gross.toFixed(2)),
//                 amount: Number(taxable.toFixed(2)),
//                 DiscAmt: Number(discAmt.toFixed(2)),
//                 taxAmount: Number(taxAmt.toFixed(2)),
//                 srNo: r.srNo,
//                 TaxId: r.TaxId || null,
//                 CGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
//                 SGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
//                 IGST: isSameState ? 0 : Number(taxPct.toFixed(2)),
//                 CGSTAmt: Number(cgstAmt.toFixed(2)),
//                 SGSTAmt: Number(sgstAmt.toFixed(2)),
//                 IGSTAmt: Number(igstAmt.toFixed(2)),
//                 UTGST: r.UTGST || '0.00',
//                 GSTCess: r.GSTCess || '0.00',
//                 challanDtsID: r.challanDtsID || null,
//                 challanID: r.challanID || null,
//                 soId: r.soId || null,
//                 soDtsID: r.soDtsID || null
//             };
//         });

//         const payload = {
//             tableData: payloadRows,
//             summary: {
//                 basic: Number(totals.basic),
//                 discount: Number(totals.discount),
//                 cgst: Number(totals.cgst),
//                 sgst: Number(totals.sgst),
//                 igst: Number(totals.igst),
//                 roundOff: Number(totals.roundOff),
//                 // total: Number(totals.total)
//                 tcsApplied: tcsEnabled ? 1 : 0,
//                 tcsPercent: tcsEnabled ? Number(tcsPercent) : 0,
//                 tcsAmount: tcsEnabled ? Number(tcsAmount) : 0,
//                 total: Number(totals.total)
//             }
//         };

//         onNext(payload);
//     };

//     const formatINR = val => {
//         const num = Number(val) || 0;
//         return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     };

//     const columns = [
//         { field: 'srNo', headerName: '#', width: 38, align: 'center', headerAlign: 'center' },
//         {
//             field: 'product', headerName: 'Product', flex: 1, sortable: false, filterable: false,
//             renderCell: params => {
//                 const { productCode, description, unit, tax, batchNo, expDate, serialNo, remark, CGSTAmt, SGSTAmt, IGSTAmt, ChallanNumber, ChallanDate } = params.row;
//                 const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//                 return (
//                     <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
//                         <Box>
//                             {/* <Typography variant="body2" fontWeight="bold" component="div" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}
//                                 onClick={e => {
//                                     e.stopPropagation();
//                                     editRow(params.row.index);
//                                 }}
//                             >
//                                 {productCode}
//                             </Typography> */}

//                             <Typography
//                                 variant="body2"
//                                 fontWeight="bold"
//                                 component="div"
//                                 sx={{
//                                     cursor: isChallanLocked ? 'not-allowed' : 'pointer',
//                                     color: isChallanLocked ? '#999' : '#1877F2',
//                                     textDecoration: isChallanLocked ? 'none' : 'underline',
//                                     fontSize: '0.85rem'
//                                 }}
//                                 onClick={e => {
//                                     e.stopPropagation();
//                                     if (mode !== 'ref' && !creditNoteExists && !isChallanLocked) {
//                                         editRow(params.row.index);
//                                     }
//                                 }}
//                             >
//                                 {productCode}
//                             </Typography>
//                             <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
//                                 {description}
//                             </Typography>
//                         </Box>
//                         <Typography variant="caption" display="block">
//                             Unit: {unit || 'N/A'} | GST: {tax}%
//                         </Typography>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                             {isSameState ? `SGST: ₹${formatINR(SGSTAmt)} + CGST: ₹${formatINR(CGSTAmt)}` : `IGST: ₹${formatINR(IGSTAmt)}`}
//                         </Typography>
//                         {(batchNo || expDate || serialNo) && (
//                             <Typography variant="caption" display="block">
//                                 {batchNo && `Batch: ${batchNo}`}
//                                 {expDate && ` | Exp: ${expDate}`}
//                             </Typography>
//                         )}
//                         {remark && (<Typography variant="caption" display="block" color="text.secondary"> Remark: {remark} </Typography>)}
//                         {(ChallanNumber || ChallanDate) && (
//                             <Typography variant="caption" display="block" color='blue'>
//                                 {ChallanNumber && `ChallanNo: ${ChallanNumber}`}
//                                 {ChallanDate && ` | Date: ${ChallanDate}`}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             }
//         },
//         { field: 'qty', headerName: 'Qty', width: 50, align: 'center', headerAlign: 'center' },
//         { field: 'rate', headerName: 'Rate', width: 100, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
//         { field: 'disc', headerName: 'Disc (%)', width: 50, align: 'center', headerAlign: 'center' },
//         { field: 'amount', headerName: 'Amount ₹', width: 100, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.TaxableAmt || 0))}` },
//         {
//             width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
//             renderCell: params => (
//                 <IconButton
//                     size="small"
//                     onClick={() => deleteRow(params.row.index)}
//                     color="error"
//                     disabled={mode === 'ref' || creditNoteExists || isChallanLocked}
//                     sx={{ opacity: mode === 'ref' ? 0.4 : 1 }}
//                 >
//                     <DeleteIcon fontSize="small" />
//                 </IconButton>
//             )
//         }
//     ];

//     return (
//         <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
//             <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
//                 <Box display="flex" flexDirection="column" gap={2} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 2, borderRight: isSmall ? 'none' : '1px solid #e0e0e0', flex: { lg: '1 1 100%' }, }} >
//                     <Box>
//                         <DropdownProductCode id="productCode" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} onProductMasterClose={handleProductAdded} connectionString={connectionString} searchBy="code" />
//                         {!!errors.productCode && (<Typography color="error" variant="caption"> {errors.productCode} </Typography>)}
//                     </Box>
//                     {/* <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} /> */}
//                     <DropdownProductCode
//                         id="description"
//                         label="Description"
//                         options={allProducts}
//                         value={current.description}
//                         onSelect={handleSelect}
//                         onNewProductAdded={loadAllProducts}
//                         connectionString={connectionString}
//                         searchBy="description"   // âœ… IMPORTANT
//                         onProductMasterClose={handleProductAdded}
//                     />
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Unit" required select fullWidth size='small' value={String(current.UnitId)} onChange={handleChange('UnitId')} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} >
//                             <option value=""></option>
//                             {unitOptions.map(u => (
//                                 <option key={u.UnitId} value={u.UnitId}>
//                                     {u.unit}
//                                 </option>
//                             ))}
//                         </TextField>
//                         {/* <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} /> */}

//                         <Dropdown
//                             id="gst"
//                             label="GST"
//                             valueKey="Id"
//                             labelKey="value"
//                             value={current.TaxId ? String(current.TaxId) : ""}
//                             options={gsts}
//                             required
//                             onChange={(opt) => {
//                                 if (!opt) {
//                                     setCurrent(prev => ({
//                                         ...prev,
//                                         tax: 0,
//                                         TaxId: null
//                                     }));
//                                 } else {
//                                     const gstValue = parseFloat(opt.value) || 0;

//                                     setCurrent(prev => ({
//                                         ...prev,
//                                         tax: gstValue,   // % value used in calculation
//                                         TaxId: opt.Id    // backend id
//                                     }));
//                                 }
//                             }}
//                         />

//                     </Box>
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Qty" required size='small' fullWidth type="number" inputProps={{ min: 0, step: 'any' }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="Rate" required size='small' fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label={getColLabel(COL.DISC, 'Disc%')} size='small' fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleChange('disc')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     </Box>
//                     <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     <Box>
//                         <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} />
//                     </Box>
//                     <Box display="flex" justifyContent="center">
//                         <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }} disabled={mode === 'ref' || creditNoteExists || isChallanLocked}>
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button>
//                     </Box>
//                 </Box>
//                 <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
//                     {isMobile ? (
//                         <Box>
//                             {rows.map((row, i) => (
//                                 <Box
//                                     key={i}
//                                     sx={{
//                                         border: "1px solid #cbd5e1",
//                                         borderRadius: 2,
//                                         p: 1.5,
//                                         mb: 1.5,
//                                         cursor: isChallanLocked ? 'not-allowed' : 'pointer',
//                                         color: isChallanLocked && "text.disabled",
//                                     }}
//                                 >
//                                     <Typography sx={{ fontWeight: 600 }}>
//                                         {row.productCode} â€”{" "}
//                                         <Box
//                                             component="span"
//                                             sx={{
//                                                 fontStyle: "italic",
//                                                 fontWeight: "normal",
//                                                 display: "inline",
//                                                 wordBreak: "break-word",
//                                                 whiteSpace: "normal"
//                                             }}
//                                         >
//                                             {row.description}
//                                         </Box>
//                                     </Typography>

//                                     {(row.ChallanNumber || row.ChallanDate) && (
//                                         <Typography variant="caption" display="block" color='blue'>
//                                             {row.ChallanNumber && `ChallanNo: ${row.ChallanNumber}`}
//                                             {row.ChallanDate && ` | Date: ${row.ChallanDate}`}
//                                         </Typography>
//                                     )}

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Qty:</Typography>
//                                         <Typography>{row.qty}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Rate:</Typography>
//                                         <Typography>₹{row.rate}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Disc:</Typography>
//                                         <Typography>{row.disc}%</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Amount:</Typography>
//                                         <Typography>₹{row.amount}</Typography>
//                                     </Grid>

//                                     {/* TAX INFO */}
//                                     <Grid container justifyContent="space-between">
//                                         <Typography>GST:</Typography>
//                                         <Typography>{row.tax}%</Typography>
//                                     </Grid>

//                                     {state?.toLowerCase() === compState?.toLowerCase() ? (
//                                         <>
//                                             <Grid container justifyContent="space-between">
//                                                 <Typography>CGST:</Typography>
//                                                 <Typography>₹{formatINR(row.CGSTAmt)}</Typography>
//                                             </Grid>
//                                             <Grid container justifyContent="space-between">
//                                                 <Typography>SGST:</Typography>
//                                                 <Typography>₹{formatINR(row.SGSTAmt)}</Typography>
//                                             </Grid>
//                                         </>
//                                     ) : (
//                                         <Grid container justifyContent="space-between">
//                                             <Typography>IGST:</Typography>
//                                             <Typography>₹{formatINR(row.IGSTAmt)}</Typography>
//                                         </Grid>
//                                     )}

//                                     {/* Remark */}
//                                     {row.remark && row.remark.trim() !== '' && (
//                                         <Typography
//                                             variant="caption"
//                                             color="text.secondary"
//                                             sx={{
//                                                 mt: 1,
//                                                 display: 'block',
//                                                 wordBreak: 'break-word',
//                                                 overflowWrap: 'anywhere',
//                                                 whiteSpace: 'normal'
//                                             }}
//                                         >
//                                             Remark: {row.remark}
//                                         </Typography>
//                                     )}

//                                     {/* DELETE / EDIT BUTTONS IF NEEDED */}
//                                     <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
//                                         <IconButton size="small" onClick={() => editRow(i)} disabled={mode === 'ref' || isChallanLocked}>
//                                             <EditIcon fontSize="small" />
//                                         </IconButton>
//                                         <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={mode === 'ref' || isChallanLocked}>
//                                             <DeleteIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>
//                                 </Box>
//                             ))}
//                         </Box>
//                     ) : (
//                         <DataGrid
//                             rows={rows.map((r, i) => ({ ...r, id: i + 1, index: i }))}
//                             columns={columns}
//                             getRowHeight={() => 'auto'}
//                             autoHeight
//                             disableRowSelectionOnClick
//                             hideFooter
//                             sx={{
//                                 mt: 5,
//                                 border: '1px solid #cbd5e1',
//                                 borderRadius: 1,
//                                 '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
//                                 '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface }
//                             }}
//                         />
//                     )}
//                     <Box mt={3}>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Basic Amount</Typography>
//                             <Typography>₹{formatINR(totals.basic)}</Typography>
//                         </Grid>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Discounted Amount</Typography>
//                             <Typography>₹{formatINR(totals.discount)}</Typography>
//                         </Grid>
//                         {state?.toLowerCase() === compState?.toLowerCase() ? (
//                             <>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>CGST</Typography>
//                                     <Typography>₹{formatINR(totals.cgst)}</Typography>
//                                 </Grid>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>SGST</Typography>
//                                     <Typography>₹{formatINR(totals.sgst)}</Typography>
//                                 </Grid>
//                             </>
//                         ) : (
//                             totals.igst > 0 && (
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>IGST</Typography>
//                                     <Typography>₹{formatINR(totals.igst)}</Typography>
//                                 </Grid>
//                             )
//                         )}
//                         {/* TCS ROW */}
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>

//                             {/* LEFT SIDE */}
//                             <Grid item display="flex" alignItems="center" gap={2}>
//                                 <FormControlLabel
//                                     control={
//                                         <Checkbox
//                                             checked={tcsEnabled}
//                                             onChange={(e) => setTcsEnabled(e.target.checked)}
//                                         />
//                                     }
//                                     label="TCS"
//                                 />

//                                 {tcsEnabled && (
//                                     <>
//                                         <TextField
//                                             label="TCS %"
//                                             size="small"
//                                             type="number"
//                                             value={tcsPercent}
//                                             onChange={(e) => {
//                                                 let val = e.target.value;

//                                                 // Allow empty (for backspace)
//                                                 if (val === '') {
//                                                     setTcsPercent('');
//                                                     return;
//                                                 }

//                                                 // Regex: numbers with max 5 decimal places
//                                                 const regex = /^\d*\.?\d{0,5}$/;

//                                                 if (!regex.test(val)) {
//                                                     return; // âŒ ignore invalid input
//                                                 }

//                                                 let num = Number(val);

//                                                 if (num < 0) num = 0;
//                                                 if (num > 100) num = 100;

//                                                 setTcsPercent(val); // keep as string for precision
//                                             }}
//                                             inputProps={{ min: 0, max: 100 }}
//                                             sx={{ width: 90 }}
//                                         />

//                                         <TextField
//                                             label="Amt"
//                                             size="small"
//                                             value={formatINR(tcsAmount)}
//                                             disabled
//                                             sx={{ width: 120 }}
//                                         />
//                                     </>
//                                 )}
//                             </Grid>

//                             {/* RIGHT SIDE (LIKE OTHER ROWS) */}
//                             <Grid item>
//                                 <Typography>
//                                     ₹{formatINR(tcsAmount)}
//                                 </Typography>
//                             </Grid>
//                         </Grid>

//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
//                             <Typography>₹{formatINR(totals.roundOff)}</Typography>
//                         </Grid>
//                         <Divider sx={{ my: 1 }} />
//                         <Grid container justifyContent="space-between" alignItems="center">
//                             <Typography fontWeight={600}>Total Amount</Typography>
//                             <Typography fontWeight={600}>₹{formatINR(totals.total)}</Typography>
//                             {/* <Typography fontWeight={600}>₹{formatINR(finalTotal)}</Typography> */}
//                         </Grid>
//                     </Box>
//                 </Box>
//             </Box>
//             {!!errors.global && (
//                 <Typography color="error" sx={{ mt: 2 }}>
//                     {errors.global}
//                 </Typography>
//             )}
//             <Box mt={1} display="flex" justifyContent="flex-end">
//                 <Button
//                     variant="contained"
//                     onClick={handleNext}
//                     disabled={isEditingMode}   // ðŸ‘‰ NEW: block Next while editing
//                 >
//                     Next
//                 </Button>

//             </Box>

//             <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
//                 <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// };

// export default ProductDetails;





import { colors as themeColors } from '../../../utils/theme';
import { useState, useEffect, useMemo, useRef } from 'react';
import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions, Alert, FormControlLabel, Checkbox, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DropdownProductCode from './DropdownProductCode';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAuth } from '../../../context/AuthContext';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import { FaCartShopping } from "react-icons/fa6";
// import SerialBatchModal from './SerialBatchModal';
import Dropdown from '../../../components/Dropdown';
import { useVisibleColumns } from '../../../hooks/useVisibleColumns';
import { useUserDefine } from '../../../context/UserDefineContext';
import { COL, DEFAULT_LABELS } from '../../../constants/columnConstants';
import { useStockValidation } from '../../../hooks/useStockValidation';
import { colors } from "../../../utils/theme";

// "Apply in Amt = Pkg*Qty*Rate?" — when this configure is enabled, a Pkg field
// containing anything that isn't a clean number (letters/special characters) must
// make the Pkg*Qty*Rate calculation come out as 0, instead of calculateAmount()'s
// own internal `Number(pkg) || 1` silently promoting invalid input back to 1.
// Blank/null/undefined Pkg is untouched — it still defaults to 1 (existing
// behavior for a fresh row before the user has typed a Pkg value).
const isGarbagePkg = (rawPkg) =>
    rawPkg !== '' && rawPkg !== null && rawPkg !== undefined && Number.isNaN(Number(rawPkg));

const getAmountCalcSafe = (qty, rate, rawPkg, disc, isApplyPkgInAmtEnabled, calculateAmount) => {
    if (isApplyPkgInAmtEnabled && isGarbagePkg(rawPkg)) {
        return { gross: 0, taxable: 0 };
    }
    return calculateAmount(qty, rate, rawPkg, disc);
};

const ProductDetails = ({ initialData, L_No, onNext, clientData, challanIds, connectionString, mode, creditNoteExists, invoiceDate, saleInvoiceId, onRowsChange }) => {
    console.log('📝 Invoice_Steeper Component initialized with L_No:', L_No);
    const { user, selectedCompany, loading, configureData } = useAuth();
    console.log('📋 Invoice_Steeper ProductDetails: configureData from useAuth:', configureData?.length || 0, 'items');
    const { validateMinLevel, isLastSaleRateEnabled, getLastSaleRate, isNegativeZeroStockBlockEnabled, validateNegativeZeroStock, isShowOnlineStockEnabled, getOnlineStockDetails, isApplyMRPInSaleEnabled, calculateSaleRateFromMRP, isDontMakeSaleInvoiceIfLimitOverEnabled, validateCreditLimit, isApplyPkgInAmtEnabled, calculateAmount, isApplyRateOnConversionEnabled, calculateConversion, isShowItemListPartywiseInSaleEnabled, isApplyPartywisePriceListDiscInSaleEnabled, getPriceListRate, getClientDiscount, getGroupWiseDisc, getPartywiseRate, isDiscSchemeEnabled, getClientDiscScheme } = useStockValidation(connectionString, selectedCompany?.CompId, selectedCompany?.AppRegID);
    console.log('🔴 Invoice_Steeper: isApplyPkgInAmtEnabled:', isApplyPkgInAmtEnabled);
    console.log('🔴 Invoice_Steeper: calculateAmount function:', typeof calculateAmount);
    const { isColVisible, getColLabel, getColRow } = useVisibleColumns('SALE');
    // RupessToBeAsk=1 ("Rupees") -> only the Oth field itself is shown (as before).
    // RupessToBeAsk=0 ("Percentage") -> also show its disabled, read-only Amount field.
    const isOthRupeesMode = (colNo) => Boolean(getColRow(colNo)?.RupessToBeAsk);
    const { getSelectedCharges, getChargeItemId, userDefineData } = useUserDefine();
    // getSelectedCharges() returns a brand-new array on every call (Array.filter),
    // even when userDefineData hasn't changed — used as a useEffect dependency
    // further down, an unstable reference there re-fires those effects (and their
    // setState calls) on every render, causing an infinite render loop. Memoize
    // on userDefineData (the actual stable source data) so the array reference
    // only changes when the underlying charges data actually changes.
    const additionalCharges = useMemo(() => getSelectedCharges('SALE'), [userDefineData]);
    const [chargesDialogOpen, setChargesDialogOpen] = useState(false);
    const [chargesCollapsibleOpen, setChargesCollapsibleOpen] = useState(true);
    const [chargeInputs, setChargeInputs] = useState({});
    // Additional Charges contribution applied to the summary panel — populated
    // only when the user clicks Save in the Charges popup (see handleSaveCharges).
    const [chargesSummary, setChargesSummary] = useState({ total: 0, cgst: 0, sgst: 0, igst: 0 });

    // Declare state and compState early (before useEffect that uses them)
    const state = clientData?.details?.['State'] || '';
    const compState = selectedCompany?.State || '';
    const [gsts, setGsts] = useState([]);

    // Restore chargeInputs and chargesSummary from initialData if provided (when returning to this step after navigation)
    useEffect(() => {
        // API chargeInputs are already keyed by TransType (200, 201, 202, 203, 204)
        // which matches charge.TransType in additionalCharges, so no mapping needed
        if (initialData?.chargeInputs && Object.keys(initialData.chargeInputs).length > 0) {
            console.log('[ChargeInputs Debug] API chargeInputs keys:', Object.keys(initialData.chargeInputs));
            console.log('[ChargeInputs Debug] additionalCharges:', additionalCharges.map(c => ({ TransType: c.TransType, SrNo: c.SrNo, name: c.ChargeName })));
            setChargeInputs(initialData.chargeInputs);
        }

        // Restore chargesSummary from charge rows in tableData (has actual calculated tax amounts)
        // This is more reliable since the API calculates taxes based on actual requirements
        if (initialData?.tableData) {
            const chargesTaxData = { total: 0, cgst: 0, sgst: 0, igst: 0 };

            initialData.tableData.forEach(row => {
                const transType = row.TransType != null ? parseInt(row.TransType) : 100;
                const isCharge = transType >= 200 && transType <= 204;
                if (isCharge) {
                    // Use the amount from the charge row
                    chargesTaxData.total += Number(row.amount || 0);
                    // Add the tax amounts from the charge row (already calculated by backend)
                    chargesTaxData.cgst += Number(row.CGSTAmt || 0);
                    chargesTaxData.sgst += Number(row.SGSTAmt || 0);
                    chargesTaxData.igst += Number(row.IGSTAmt || 0);
                }
            });

            console.log('[ChargesSummary Debug] Calculated from tableData:', chargesTaxData);

            if (chargesTaxData.total > 0 || chargesTaxData.cgst > 0 || chargesTaxData.sgst > 0 || chargesTaxData.igst > 0) {
                setChargesSummary(chargesTaxData);
            }
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setChargesSummary call) on every parent re-render, not just when
        // the actual saved charge data changes.
    }, [initialData?.chargeInputs, initialData?.tableData]);

    // TEMP DEBUG — remove once the "Charges" button visibility issue is confirmed fixed.
    useEffect(() => {
        console.log('[Charges Debug] userDefineData.additionalCharges.SALE (raw):', userDefineData?.additionalCharges?.SALE);
        console.log('[Charges Debug] filtered (ColToBeAsk=1) for button:', additionalCharges);
    }, [userDefineData, additionalCharges]);

    // Populate each charge slot's editable state (Amount, and Tax when TaxEnabled)
    // fresh every time the popup opens — default Tax is whatever was saved for
    // that slot in UserDefineColumns (charge.TaxId). Preserve amount if already restored from initialData.
    useEffect(() => {
        if (!chargesDialogOpen) return;
        setChargeInputs(prev => {
            const next = { ...prev };
            additionalCharges.forEach(charge => {
                const key = charge.TransType;
                if (!next[key]) {
                    // Only set empty amount if not already populated (e.g., from initialData restore)
                    next[key] = {
                        amount: '',
                        taxId: charge.TaxId ?? null,
                    };
                } else {
                    // Preserve existing amount, but update taxId to the configured one if not already set
                    if (next[key].taxId === null && charge.TaxId !== null) {
                        next[key].taxId = charge.TaxId;
                    }
                }
            });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargesDialogOpen]);

    const updateChargeInput = (key, patch) => {
        setChargeInputs(prev => ({
            ...prev,
            [key]: { ...prev[key], ...patch },
        }));
    };
    const companyId = selectedCompany?.CompId || null;
    console.log("ididi", initialData)
    console.log('challanIds:', challanIds);
    console.log(`state: ${state} || compState: ${compState}`);
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    console.log("invoiceDate", invoiceDate)
    const [rows, setRows] = useState([]);
    const [nextSrNo, setNextSrNo] = useState(1);
    const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, MRP: '', batchNo: '', expDate: '', serialNo: '', amount: '', taxAmount: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, PONo: '', PODate: '', poQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', GSTOth: '0.00', ex4: '', ex5: '', exQty6: '', serialNo: '', oth4: '', oth5: '', oth6: '', oth7: '', GSTCEssAmt: '0.00', GSTEduCess: '0.00', GSTEducessAmt: '',
        // "Enable Convesrion effect in Transaction?" fields — defaultUnitId/convUnitId/productConvQty
        // are captured once at product-select time from productmaster (UnitId/
        // ConvUnit/ConvQty) and never change while this row's product stays the
        // same. baseRate preserves the rate as it stood before any conversion
        // division, so switching Unit back to defaultUnitId can restore it exactly.
        // ConversionQty/ConversionRate are only non-null while a conversion is
        // actively applied to this row (see saleinvoicedetails.ConversionQty/
        // ConversionRate columns) — both map 1:1 onto payload/stock fields.
        defaultUnitId: '', convUnitId: '', productConvQty: '', baseRate: 0, ConversionQty: null, ConversionRate: null });
    const [totals, setTotals] = useState({ basic: 0, grossBasic: 0, discount: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, total: 0 });
    const [errors, setErrors] = useState({});
    const [editIndex, setEditIndex] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]);
    const [colorMap, setColorMap] = useState({});
    const [sizeMap, setSizeMap] = useState({});
    // const [originalEditQty, setOriginalEditQty] = useState(null);
    const [isEditingMode, setIsEditingMode] = useState(false);

    const [isInitialized, setIsInitialized] = useState(false);

    // Track if component has finished initializing
    const hasInitializedRef = useRef(false);

    // When true, the next run of the live-calculation effect is skipped —
    // set right before a row's DB values are loaded into `current` (editRow),
    // so entering edit mode doesn't immediately overwrite the stored amount.
    const skipNextCalcRef = useRef(false);

    // Ref to the Product Code field for auto-focus
    const productCodeRef = useRef(null);

    // Notify parent when rows change â€” but ONLY after initialization is done
    useEffect(() => {
        if (!hasInitializedRef.current) return;
        if (onRowsChange) {
            onRowsChange(rows);
        }
    }, [rows]);

    // Reset isInitialized when coming back with data but rows are empty
    useEffect(() => {
        if (initialData?.tableData?.length && rows.length === 0 && hasInitializedRef.current) {
            setIsInitialized(false);
        }
    }, [initialData?.tableData]);

    // For add mode â€” no initialData, so mark as initialized immediately
    useEffect(() => {
        if (!initialData?.tableData?.length) {
            hasInitializedRef.current = true;
        }
    }, []);

    const [discError, setDiscError] = useState("");
    const [modalStockDetails, setModalStockDetails] = useState({
        stock: [],
        selected: []
    });
    const [modalOpenTrigger, setModalOpenTrigger] = useState(0);

    const [serBatchModalOpen, setSerBatchModalOpen] = useState(false);
    const [modalResetKey, setModalResetKey] = useState(0);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "error",
        details: []   // â† add this
    });

    const [stockWarningOpen, setStockWarningOpen] = useState(false);
    const [stockWarningData, setStockWarningData] = useState(null);
    const [stockConfirmResolve, setStockConfirmResolve] = useState(null);
    const [zeroStockErrorOpen, setZeroStockErrorOpen] = useState(false);
    const [zeroStockErrorData, setZeroStockErrorData] = useState(null);
    // "Enable Convesrion effect in Transaction?" — popup shown whenever the row's Unit is
    // changed away from the product's own default Unit. pendingUnit holds the
    // in-progress selection (unit id/name + resolved unit ratio) until the user
    // confirms or cancels; previousUnitId lets Cancel revert the <select> back to
    // whatever it was before this change, per spec (no half-applied Unit change).
    const [conversionQtyDialogOpen, setConversionQtyDialogOpen] = useState(false);
    const [conversionQtyInput, setConversionQtyInput] = useState('');
    const [pendingUnitChange, setPendingUnitChange] = useState(null); // { UnitId, unit, previousUnitId }
    const [onlineStockDetails, setOnlineStockDetails] = useState({
        closingStock: null,
        maxLevel: null,
        minLevel: null,
    });

    const [trackingType, setTrackingType] = useState(null);

    const [errorDialog, setErrorDialog] = useState({ open: false, details: [], type: '', creditLimitData: {} });
    const [creditLimitOverride, setCreditLimitOverride] = useState(false);

    const [initialAdvanceRows, setInitialAdvanceRows] = useState([]);

    const [trackingConfig, setTrackingConfig] = useState({
        applyBatchNo: 0,
        applySerialNo: 0,
        expiryDays: 0,
        warrantyMonths: 0
    });


    const [tcsEnabled, setTcsEnabled] = useState(false);
    const [tcsPercent, setTcsPercent] = useState(0);
    const [tcsAmount, setTcsAmount] = useState(0);
    const [tcsDisabled, setTcsDisabled] = useState(false);


    const [advanceReceipts, setAdvanceReceipts] = useState([]);
    const [showAdvanceCheckbox, setShowAdvanceCheckbox] = useState(false);
    const [adjustAdvance, setAdjustAdvance] = useState(false);

    const [adjustAdvancePayment, setAdjustAdvancePayment] = useState(false);
    const [adjustAmt, setAdjustAmt] = useState(0);
    const [closingBalAmount, setClosingBalAmount] = useState(0);
    const [advancePaymentMessage, setAdvancePaymentMessage] = useState('');
    const [advancePaymentLoading, setAdvancePaymentLoading] = useState(false);
    const [adjustAmtError, setAdjustAmtError] = useState('');

    const [advanceDialogOpen, setAdvanceDialogOpen] = useState(false);
    const [selectedAdvanceRows, setSelectedAdvanceRows] = useState([]);

    const [confirmAdvanceResetOpen, setConfirmAdvanceResetOpen] = useState(false);

    const advanceManuallySet = useRef(initialData?.advanceUnchecked === true);


    //get advance receipt
    useEffect(() => {


        console.log("mode", mode)


        // âŒ skip in edit mode having advance enteries
        if (
            mode === "edit" &&
            initialData?.advanceReceipts?.length > 0
        ) {
            return;
        }

        const fetchAdvanceReceipts = async () => {

            if (!clientData?.clientId || !companyId) {
                setAdvanceReceipts([]);
                setShowAdvanceCheckbox(false);
                return;
            }

            try {

                const res = await axios.get(
                    `${connectionString}/api/get-advance-payReceipt`,
                    {
                        params: {
                            companyId,
                            partyId: clientData.clientId,
                            type: "receipt"
                        }
                    }
                );

                if (res.data?.success) {

                    const data = res.data.data || [];

                    // setAdvanceReceipts(data);
                    setAdvanceReceipts(
                        data.map(item => ({
                            ...item,
                            AdjustAmount: item.DisplayAdvanceAmount
                        }))
                    );

                    // show checkbox only if advance exists
                    setShowAdvanceCheckbox(prev => prev || data.length > 0);

                }

            } catch (error) {

                console.error("Error fetching advance receipts", error);

                setAdvanceReceipts([]);
                setShowAdvanceCheckbox(false);
            }
        };

        fetchAdvanceReceipts();

    }, [clientData?.clientId, companyId, mode, adjustAdvance]);

    // ================= EDIT MODE ADVANCE RECEIPTS =================

    useEffect(() => {

        if (mode !== "edit") return;

        const existingAdvance =
            initialData?.advanceReceipts || [];

        // save original rows once
        setInitialAdvanceRows(existingAdvance);

        // user already unchecked previously
        if (initialData?.advanceUnchecked) {

            setShowAdvanceCheckbox(true);

            setAdjustAdvance(false);

            setSelectedAdvanceRows([]);

            return;
        }

        if (existingAdvance.length > 0) {

            setShowAdvanceCheckbox(true);

            setAdvanceReceipts(existingAdvance);

            setSelectedAdvanceRows(
                existingAdvance.map(item => ({
                    ...item,
                    isManual: true
                }))
            );

            setAdjustAdvance(true);
        }

    }, [initialData, mode]);

    // Recalculate Rate from MRP when GST (TaxId) changes, if Apply MRP in Sale is enabled
    useEffect(() => {
        // `current` was just loaded from a saved row (editRow) — skip this one
        // pass so the DB-stored amount isn't immediately overwritten before the
        // user has actually changed the GST/TaxId themselves.
        if (skipNextCalcRef.current) {
            return;
        }

        if (!isApplyMRPInSaleEnabled || !current.MRP || Number(current.MRP) <= 0) return;

        const matchedGST = gsts.find(g => String(g.Id) === String(current.TaxId));
        if (!matchedGST) return;

        const tax = getTaxPercent(matchedGST.value);
        const newRate = calculateSaleRateFromMRP(Number(current.MRP), tax);
        const amountCalc = getAmountCalcSafe(current.qty, newRate, current.pkg, current.disc, isApplyPkgInAmtEnabled, calculateAmount);
        const taxableAmt = amountCalc.taxable;
        const taxAmount = taxableAmt * (tax / 100);

        console.log('🔄 Invoice_Steeper: GST changed, recalculating Rate from MRP:', { MRP: current.MRP, tax, newRate });

        setCurrent(prev => ({
            ...prev,
            rate: newRate,
            tax,
            amount: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
            TaxableAmt: taxableAmt.toFixed(2)
        }));
    }, [current.TaxId, isApplyMRPInSaleEnabled, gsts]);

    // Handle Advance Payment checkbox click
    const handleAdvancePaymentChange = async (e) => {
        const checked = e.target.checked;

        if (!checked) {
            // Unchecked - clear messages and amounts
            setAdjustAdvancePayment(false);
            setAdvancePaymentMessage('');
            setAdjustAmt(0);
            return;
        }

        // Checked - keep checkbox checked and fetch closing balance
        setAdjustAdvancePayment(true);

        // Check client information
        if (!clientData?.clientId || !companyId) {
            setAdvancePaymentMessage('Client information is missing');
            return;
        }

        setAdvancePaymentLoading(true);
        setAdvancePaymentMessage('');

        try {
            const res = await axios.get(
                `${connectionString}/api/get-closing-balance`,
                {
                    params: {
                        partyId: clientData.clientId,
                        companyId,
                        mode: 'SALE'
                    }
                }
            );

            console.log(res.data);

            if (res.data?.success) {
                const closingBal = res.data.closingBalance || 0;

                // If closingBalance > 0, advance exists
                if (closingBal > 0) {
                    // Calculate AdjustAmt: if closingBal < billAmount then show closingBal, else show billAmount
                    const billAmount = Number(totals.total || 0);
                    const finalAdjustAmt = closingBal < billAmount ? closingBal : billAmount;

                    setClosingBalAmount(closingBal);
                    setAdjustAmt(finalAdjustAmt);
                    setAdjustAmtError('');
                    setAdvancePaymentMessage(`Advance Available: ₹${formatINR(closingBal)}`);
                } else {
                    // closingBalance = 0, no advance
                    setAdvancePaymentMessage('There is no Advance Payment');
                    setClosingBalAmount(0);
                    setAdjustAmt(0);
                    setAdjustAmtError('');
                }
            } else {
                setAdvancePaymentMessage('Error fetching advance information');
                setClosingBalAmount(0);
                setAdjustAmt(0);
                setAdjustAmtError('');
            }
        } catch (error) {
            console.error("Error fetching closing balance:", error);
            setAdvancePaymentMessage('Error fetching advance information');
            setClosingBalAmount(0);
            setAdjustAmt(0);
            setAdjustAmtError('');
        } finally {
            setAdvancePaymentLoading(false);
        }
    };

    const handleAdjustAdvanceChange = (e) => {

        const checked = e.target.checked;

        advanceManuallySet.current = true;

        // CHECKED AGAIN
        if (checked) {

            setAdjustAdvance(true);

            // restore original edit rows
            setAdvanceReceipts(initialAdvanceRows);

            setSelectedAdvanceRows(
                initialAdvanceRows.map(item => ({
                    ...item,
                    isManual: true
                }))
            );

            return;
        }

        // âŒ DON'T RESET DIRECTLY
        // open confirmation dialog first
        setConfirmAdvanceResetOpen(true);
    };


    const confirmAdvanceReset = () => {

        setAdjustAdvance(false);

        setAdvanceDialogOpen(false);

        setSelectedAdvanceRows([]);

        setAdvanceReceipts([]);

        setConfirmAdvanceResetOpen(false);
    };

    const cancelAdvanceReset = () => {

        setConfirmAdvanceResetOpen(false);
    };


    useEffect(() => {
        if (!tcsEnabled) {
            setTcsAmount(0);
            return;
        }

        const baseAmount =
            Number(totals.basic || 0) +
            Number(totals.cgst || 0) +
            Number(totals.sgst || 0) +
            Number(totals.igst || 0);

        const tcs = (baseAmount * Number(tcsPercent || 0)) / 100;

        setTcsAmount(tcs);
    }, [tcsEnabled, tcsPercent, totals]);


    useEffect(() => {
        if (!initialData?.summary) return;

        const s = initialData.summary;

        setTcsEnabled(s.tcsApplied === 1);
        setTcsPercent(s.tcsPercent || 0);
        setTcsAmount(s.tcsAmount || 0);

        // Initialize advance payment fields for edit mode
        // Map backend field names to frontend field names
        const advancePaymentChecked = initialData?.adjustAdvancePayment !== undefined
            ? Number(initialData.adjustAdvancePayment) === 1
            : (initialData?.IsAdvPmt !== undefined ? Number(initialData.IsAdvPmt) === 1 : false);

        const advanceAmount = initialData?.adjustAmt !== undefined
            ? parseFloat(String(initialData.adjustAmt).replace(/[^\d.]/g, '')) || 0
            : (initialData?.AdvPmtAmt !== undefined ? parseFloat(String(initialData.AdvPmtAmt).replace(/[^\d.]/g, '')) || 0 : 0);

        const closingBalance = initialData?.closingBalAmount !== undefined
            ? parseFloat(String(initialData.closingBalAmount).replace(/[^\d.]/g, '')) || 0
            : (initialData?.PaidAmt !== undefined ? parseFloat(String(initialData.PaidAmt).replace(/[^\d.]/g, '')) || 0 : 0);

        setAdjustAdvancePayment(advancePaymentChecked);
        setAdjustAmt(advanceAmount);
        setClosingBalAmount(closingBalance);

        console.log('Initialized advance payment:', {
            adjustAdvancePayment: advancePaymentChecked,
            adjustAmt: advanceAmount,
            closingBalAmount: closingBalance,
            rawAdjustAdvancePayment: initialData?.adjustAdvancePayment,
            rawAdjustAmt: initialData?.adjustAmt,
            rawClosingBalAmount: initialData?.closingBalAmount
        });
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setState calls) on every parent re-render, not just when the
        // actual saved values change.
    }, [initialData?.summary, initialData?.adjustAdvancePayment, initialData?.adjustAmt, initialData?.IsAdvPmt, initialData?.AdvPmtAmt, initialData?.closingBalAmount, initialData?.PaidAmt]);

    // Check if CategoryId 18 exists in clientmaster
    useEffect(() => {
        const checkTcsClientExists = async () => {
            if (!companyId) {
                setTcsDisabled(true);
                return;
            }

            try {
                const res = await axios.get(
                    `${connectionString}/api/check-client-category`,
                    {
                        params: {
                            companyId,
                            categoryId: 18
                        }
                    }
                );

                const exists = res.data?.success && res.data?.exists;
                setTcsDisabled(!exists);

                // If TCS client doesn't exist and TCS is enabled, disable it
                if (!exists) {
                    setTcsEnabled(false);
                    setTcsPercent(0);
                    setTcsAmount(0);
                }
            } catch (error) {
                console.error("Error checking TCS client existence:", error);
                setTcsDisabled(true);
            }
        };

        checkTcsClientExists();
    }, [companyId, connectionString]);

    console.log("clientData", clientData.clientId)


    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const getTaxPercent = (value) => {
        if (!value) return 0;
        const cleaned = value.replace('%', '').trim();
        const parsed = parseFloat(cleaned);
        return isNaN(parsed) ? 0 : parsed;
    };

    const isTrackingEnabled = useMemo(() => {
        if (!Array.isArray(configureData)) return false;

        return configureData.some(c => c.ApplyConfigure === 1);
    }, [configureData]);

    // ADD after requiredAsteriskStyle
    const API_BASE = `${connectionString}/api`;

    const transformGSTs = data => Array.isArray(data) ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode })) : [];

    const Hlp_Fn_GST = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
            console.log(data);
            setGsts(transformGSTs(data));
        } catch (e) {
            console.error('GST lookup failed', e);
            setSnackbar(prev => ({    // âœ… reuse existing snackbar
                ...prev,
                open: true,
                message: 'GST lookup failed.',
                severity: 'error'
            }));
            setGsts([]);
        }
    };

    useEffect(() => {
        Hlp_Fn_GST();
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, { params: { companyId } });
                setUnitOptions(unitsRes.data); // Expecting [{ UnitId: 43, unit: "NOS" }, ...]
                const [cRes, sRes] = await Promise.all([
                    axios.get(`${connectionString}/api/colormaster`),
                    axios.get(`${connectionString}/api/sizemaster`)
                ]);
                const cm = {}, sm = {};
                cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
                sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
                setColorMap(cm);
                setSizeMap(sm);
            } catch (error) {
                console.error('Error fetching product or unit data:', error);
            }
        };

        fetchData();
        loadAllProducts();
    }, []);

    const handleProductAdded = async () => {
        // Reload units when product is added
        try {
            const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, {
                params: { companyId }
            });
            setUnitOptions(unitsRes.data);

            // Also reload products
            await loadAllProducts();
        } catch (error) {
            console.error('Error refreshing data:', error);
        }
    };

    const loadAllProducts = async () => {
        try {
            // When "Show Item List Partywise in Sale?" is enabled, pass partyId so the
            // API joins with partywiserate and returns only items configured for this client.
            const params = { companyId, mode: 'SALE' };
            if (isShowItemListPartywiseInSaleEnabled && clientData?.clientId) {
                params.partyId = clientData.clientId;
                params.AppRegID = selectedCompany?.AppRegID;
            }

            const res = await axios.get(`${connectionString}/api/productdata/retrive`, { params });
            setAllProducts(res.data || []);
            console.log(res.data)
        } catch (e) {
            console.error('Error fetching products:', e);
        }
    };

    useEffect(() => {
        if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !unitOptions.length || !allProducts.length) {
            return;
        }

        // The products grid (`rows`) must only ever hold normal product rows.
        // Additional Charges (TransType 200-204) and RoundOff (300) are restored
        // separately (chargeInputs / roundOff field) and re-added at submit time —
        // including them here as well would duplicate them in the outgoing payload.
        const regularRows = initialData.tableData.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);

        const initialRows = regularRows.map((r, index) => {
            const regularIndex = index;
            const srNoValue = regularRows.length - regularIndex;
            const qty =
                mode === 'ref'
                    ? Number(r.dispQty ?? r.qty) || 0
                    : Number(r.qty) || 0;
            const rate = Number(r.rate) || 0;
            const pkg = Number(r.pkg) || 1;  // Load pkg from incoming data, default to 1
            const disc = Number(r.disc) || 0;
            // Prefer the exact amount stored in the database — never recompute it
            // from today's live Pkg-flag setting, since that flag may have changed
            // since this row was originally saved. Only fall back to a fresh
            // calculation when the DB genuinely has no stored amount for this row.
            const storedAmt = r.TaxableAmt ?? r.amount;
            const hasStoredAmt = storedAmt != null && storedAmt !== '' && !Number.isNaN(Number(storedAmt));
            const taxableAmt = hasStoredAmt ? Number(storedAmt) : getAmountCalcSafe(qty, rate, r.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
            let taxId = r.taxId || r.TaxId || null;

            const product = allProducts.find(p => p.Id === r.productId || p.itemCode === r.productCode);

            //  GST lookup
            const matchedGST = gsts.find(g => String(g.Id) === String(taxId));

            //  final %
            let tax = matchedGST
                ? getTaxPercent(matchedGST.value)
                : Number(r.tax) || (Number(r.CGST) + Number(r.SGST)) || Number(r.IGST) || 0;

            let taxAmount = taxableAmt * (tax / 100);
            let cgst = '0.00', sgst = '0.00', igst = '0.00';
            let cgstAmt = '0.00', sgstAmt = '0.00', igstAmt = '0.00';
            const matchedUnit =
                unitOptions.find(u => String(u.UnitId) === String(r.UnitId)) ||
                unitOptions.find(u => u.unit?.toLowerCase() === String(r.unit).toLowerCase()) ||
                (product ? unitOptions.find(u =>
                    String(u.UnitId) === String(product.UnitId) ||
                    u.unit?.toLowerCase() === String(product.Unit?.toLowerCase())
                ) : null);

            if (product) {
                tax = tax;       //  backend value
                taxId = r.taxId || r.TaxId || null;        //  backend value
                taxAmount = taxableAmt * (tax / 100);
                cgst = state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00';
                sgst = state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00';
                igst = state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00';
                cgstAmt = state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00';
                sgstAmt = state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00';
                igstAmt = state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00';
            } else {
                taxAmount = taxableAmt * (tax / 100);
                cgst = Number(r.CGST || (state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2) : 0)).toFixed(2);
                sgst = Number(r.SGST || (state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2) : 0)).toFixed(2);
                igst = Number(r.IGST || (state?.toLowerCase() !== compState?.toLowerCase() ? tax : 0)).toFixed(2);
                cgstAmt = Number(r.CGSTAmt || (state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2) : 0)).toFixed(2);
                sgstAmt = Number(r.SGSTAmt || (state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2) : 0)).toFixed(2);
                igstAmt = Number(r.IGSTAmt || (state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount : 0)).toFixed(2);
            }

            return {
                ...r,
                productId: r.productId || r.Id || r.id || '',
                UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId || ''),
                unit: matchedUnit ? matchedUnit.unit : (product?.Unit || ''),
                qty,
                rate,
                pkg,  // Include pkg in the row
                dispQty: Number(r.dispQty) || 0,
                disc,
                tax,
                TaxableAmt: taxableAmt.toFixed(2),
                taxAmount: Number(r.taxAmount) || taxAmount.toFixed(2),
                amount: taxableAmt.toFixed(2),
                CGST: cgst,
                SGST: sgst,
                IGST: igst,
                CGSTAmt: cgstAmt,
                SGSTAmt: sgstAmt,
                IGSTAmt: igstAmt,
                UTGST: String(r.UTGST || '0.00'),
                GSTCess: String(r.GSTCess || '0.00'),
                TaxId: taxId,
                srNo: srNoValue,
                challanDtsID: r.challanDtsID || null,
                challanID: r.challanID || null,
                soId: r.soId || null,
                soDtsID: r.soDtsID || null,
                // "Enable Convesrion effect in Transaction?" — these fields are UI/session-only and
                // were never part of the saved row, so re-derive them here from the
                // product's CURRENT registered defaults (same logic as handleSelect)
                // whenever a saved invoice is loaded back into edit/ref mode. Without
                // this, editRow's `{...row}` spread would leave defaultUnitId unset,
                // silently disabling the Unit-change conversion prompt in edit mode.
                // baseRate must stay the ORIGINAL pre-conversion rate: if this row was
                // saved with a conversion active, that's r.ConversionRate (not r.rate,
                // which is already the divided/billed rate); otherwise it's r.rate.
                defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId ? String(product.UnitId) : ''),
                convUnitId: product?.ConvUnit ? String(product.ConvUnit) : '',
                productConvQty: Number(product?.ConvQty) || '',
                baseRate: r.ConversionRate != null ? Number(r.ConversionRate) : rate,
                configData: (r.configData || []).map(item => {
                    const rawIsSelected = item.is_selected != null
                        ? Number(item.is_selected)
                        : (Number(item.selected_qty) > 0 ? 1 : 0);

                    const rawSelectedQty = Number(item.selected_qty) || 0;

                    return {
                        ...item,
                        id: Number(item.id),
                        is_selected: rawIsSelected,
                        selected_qty: rawIsSelected === 1 && rawSelectedQty === 0
                            ? 1
                            : rawSelectedQty,
                        available_qty: Number(item.available_qty) || 0,
                        display_qty: item.display_qty != null
                            ? Number(item.display_qty)
                            : undefined,
                        // ADD THIS
                        actual_stock:
                            item.actual_stock != null
                                ? Number(item.actual_stock)
                                : 0,
                        qty: Number(item.qty) || 1
                    };
                })
            };
        });

        setRows(initialRows);
        setNextSrNo(initialRows.length + 1);
        setIsInitialized(true);
        hasInitializedRef.current = true; // â† for lifting rows state up
    }, [initialData?.tableData, unitOptions, allProducts, state, compState, gsts, isInitialized]);

    // Re-load products when party-wise filter config or selected client changes
    // to ensure dropdown always shows the correct filtered list based on current settings
    useEffect(() => {
        loadAllProducts();
    }, [isShowItemListPartywiseInSaleEnabled, clientData?.clientId]);

    useEffect(() => {
        // `current` was just loaded from a saved row (editRow) — skip this one
        // pass so the DB-stored amount isn't immediately overwritten before the
        // user has actually changed anything.
        if (skipNextCalcRef.current) {
            skipNextCalcRef.current = false;
            return;
        }

        const qty = Number(current.qty) || 0;
        const rate = Number(current.rate) || 0;
        const pkg = Number(current.pkg) || 1;  // Default to 1 if not provided or 0
        const disc = Number(current.disc) || 0;
        const tax = Number(current.tax) || 0;

        // Calculate based on configuration: use calculateAmount function
        const amountCalc = getAmountCalcSafe(qty, rate, current.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount);
        const taxableAmt = amountCalc.taxable;
        const taxAmount = taxableAmt * (tax / 100);

        console.log('💰 Amount calculation:', { qty, rate, pkg, disc, isApplyPkgInAmtEnabled, taxableAmt });

        setCurrent(prev => ({
            ...prev,
            TaxableAmt: taxableAmt.toFixed(2),
            amount: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00'
        }));
    }, [current.qty, current.rate, current.pkg, current.disc, current.tax, state, compState, isApplyPkgInAmtEnabled, calculateAmount]);

    useEffect(() => {
        const n = v => Number(v || 0);
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();

        let basicAmountSum = 0;
        // Display/storage-only: sum of qty*rate per row, BEFORE Disc% and
        // before Oth1-7 — does not feed subTotal/tax/roundOff/TaxableAmt,
        // which all keep using basicAmountSum (the Oth-adjusted taxable total)
        // exactly as before.
        let grossAmountSum = 0;
        let discountTotal = 0;
        let cgstTotal = 0;
        let sgstTotal = 0;
        let igstTotal = 0;

        rows.forEach((r, idx) => {
            // Only include normal product rows (TransType 100) in totals
            // Exclude Additional Charges (TransType 200-204) and RoundOff (TransType 300)
            const transType = r.TransType != null ? parseInt(r.TransType) : 100;
            const isNormalProduct = transType === 100;
            if (!isNormalProduct) return;

            // The row currently being edited is represented live by `current` state
            // below — skip its stale DB values here so it isn't counted twice.
            const isBeingEdited = editIndex != null && idx === editIndex;

            let qty, rate, taxable, taxPct, cgstAmtRow, sgstAmtRow, igstAmtRow, discAmtRow;

            if (isBeingEdited) {
                qty = n(current.qty);
                rate = n(current.rate);
                taxable = n(current.TaxableAmt || current.amount);
                taxPct = n(current.tax);
                const gross = getAmountCalcSafe(qty, rate, current.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
                grossAmountSum += gross;
                // Disc% is against gross only — independent of any Oth1-7
                // adjustment baked into `taxable`, which is the final amount.
                discAmtRow = gross * (n(current.disc) / 100);
                cgstAmtRow = (current.CGSTAmt != null && current.CGSTAmt !== '') ? n(current.CGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
                sgstAmtRow = (current.SGSTAmt != null && current.SGSTAmt !== '') ? n(current.SGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
                igstAmtRow = (current.IGSTAmt != null && current.IGSTAmt !== '') ? n(current.IGSTAmt) : (isSameState ? 0 : taxable * (taxPct / 100));
            } else {
                qty = n(r.qty);
                rate = n(r.rate);
                const gross = getAmountCalcSafe(qty, rate, r.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
                grossAmountSum += gross;
                taxable = n(r.amount || r.TaxableAmt);
                // Disc% is against gross only — independent of any Oth1-7
                // adjustment baked into `taxable`, which is the final amount.
                discAmtRow = gross * (n(r.disc) / 100);
                taxPct = n(r.tax);
                cgstAmtRow = (r.CGSTAmt != null && r.CGSTAmt !== '') ? n(r.CGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
                sgstAmtRow = (r.SGSTAmt != null && r.SGSTAmt !== '') ? n(r.SGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
                igstAmtRow = (r.IGSTAmt != null && r.IGSTAmt !== '') ? n(r.IGSTAmt) : (isSameState ? 0 : taxable * (taxPct / 100));
            }

            basicAmountSum += taxable;
            discountTotal += discAmtRow;
            cgstTotal += cgstAmtRow;
            sgstTotal += sgstAmtRow;
            igstTotal += igstAmtRow;
        });

        const totalTax = cgstTotal + sgstTotal + igstTotal;

        // âœ… Subtotal
        const subTotal = basicAmountSum + totalTax;

        // âœ… TCS on (Basic + GST)
        const tcs = tcsEnabled
            ? (subTotal * Number(tcsPercent || 0)) / 100
            : 0;

        // Additional Charges (amount + their own CGST/SGST/IGST) must be folded in
        // here, before rounding, otherwise Round Off is computed against the
        // pre-charges amount and Total (basic+tax+charges+roundOff) stops adding up.
        const chargesTotal = Number(chargesSummary.total || 0)
            + Number(chargesSummary.cgst || 0)
            + Number(chargesSummary.sgst || 0)
            + Number(chargesSummary.igst || 0);

        // âœ… FINAL BEFORE ROUND OFF (IMPORTANT)
        const finalAmount = subTotal + tcs + chargesTotal;

        // const roundedFinal = Math.ceil(finalAmount);
        // const roundOff = Number((roundedFinal - finalAmount).toFixed(2));
        const decimalPart = finalAmount - Math.floor(finalAmount);

        const roundedFinal =
            decimalPart >= 0.5
                ? Math.ceil(finalAmount)
                : Math.floor(finalAmount);

        const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

        setTotals({
            basic: basicAmountSum.toFixed(2),
            grossBasic: grossAmountSum.toFixed(2),
            discount: discountTotal.toFixed(2),
            cgst: cgstTotal.toFixed(2),
            sgst: sgstTotal.toFixed(2),
            igst: igstTotal.toFixed(2),
            roundOff: roundOff.toFixed(2),
            total: roundedFinal.toFixed(2)
        });
    }, [rows, editIndex, current, state, compState, tcsEnabled, tcsPercent, chargesSummary]);

    // Additional Charges: given a charge and its current popup input, compute
    // the charge amount, the tax on it (only when TaxEnabled), and the final
    // (tax-inclusive) amount — this is what "Final Amount" displays live.
    const getChargeFinalAmounts = (charge, input) => {
        const chargeAmount = Number(input?.amount) || 0;
        if (!charge.TaxEnabled) {
            return { chargeAmount, taxPercent: 0, taxAmount: 0, finalAmount: chargeAmount };
        }
        const selectedGST = gsts.find(g => String(g.Id) === String(input?.taxId));
        const taxPercent = parseFloat(selectedGST?.value) || 0;
        const taxAmount = chargeAmount * taxPercent / 100;
        return { chargeAmount, taxPercent, taxAmount, finalAmount: chargeAmount + taxAmount };
    };

    // Additional Charges: on Save, fold every charge's final amount into the
    // Total Amount shown in the summary, and its tax (if any) into CGST+SGST
    // (same state) or IGST (different state) — same split rule the totals
    // effect above already uses for product rows.
    const handleSaveCharges = () => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
        setChargesDialogOpen(false);
    };

    // ✅ Auto-sync chargesSummary with chargeInputs whenever charges are entered
    // This ensures charges are calculated in real-time without needing a Save button
    useEffect(() => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
    }, [chargeInputs, additionalCharges, state, compState, gsts]);

    const fetchStock = async (payload) => {
        try {
            const res = await axios.post(
                `${connectionString}/api/get-stock-by-item`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return res.data;
        } catch (error) {
            console.error("API Error:", error);
            return {
                success: false,
                message: "Something went wrong",
            };
        }
    };

    const totalSelectedAdvance =
        selectedAdvanceRows.reduce(
            (sum, item) =>
                sum + Number(item.AdjustAmount || 0),
            0
        );

    const availableAdvanceAmount = advanceReceipts.reduce(
        (sum, item) => sum + Number(item.DisplayAdvanceAmount || 0),
        0
    );

    const remainingAdvanceAmount =
        Number(totals.total || 0) - totalSelectedAdvance;

    const handleAdvanceSelection = (selectionModel) => {

        // keep already selected rows unchanged
        let updatedRows = selectedAdvanceRows.filter(row =>
            selectionModel.includes(row.ReceiptId)
        );

        // total already used
        let usedAmount = updatedRows.reduce(
            (sum, row) => sum + Number(row.AdjustAmount || 0),
            0
        );

        // newly selected ids only
        const newSelectedIds = selectionModel.filter(
            id => !updatedRows.some(r => r.ReceiptId === id)
        );

        newSelectedIds.forEach(id => {

            const item = advanceReceipts.find(
                r => r.ReceiptId === id
            );

            if (!item) return;

            const remaining =
                Number(totals.total || 0) - usedAmount;

            // stop if no balance left
            if (remaining <= 0) return;

            const autoAmount = Math.min(
                Number(item.DisplayAdvanceAmount || 0),
                remaining
            );

            updatedRows.push({
                ...item,
                AdjustAmount: autoAmount,
                isManual: false
            });

            usedAmount += autoAmount;
        });

        setSelectedAdvanceRows(updatedRows);
    };

    // const handleChange = field => e => {
    //     if (field === 'UnitId') {
    //         const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
    //         setCurrent(prev => ({
    //             ...prev,
    //             UnitId: e.target.value,
    //             unit: selectedUnit ? selectedUnit.unit : ''
    //         }));
    //     } else {
    //         setCurrent(prev => ({ ...prev, [field]: e.target.value }));
    //     }
    // };

    // const handleChange = field => e => {
    //     if (field === 'UnitId') {
    //         const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
    //         setCurrent(prev => ({
    //             ...prev,
    //             UnitId: e.target.value,
    //             unit: selectedUnit ? selectedUnit.unit : ''
    //         }));
    //     } else if (field === 'qty') {
    //         let value = e.target.value;
    //         let numeric = Number(value) || 0;

    //         // When editing an existing row, do NOT allow qty > originalEditQty
    //         if (editIndex != null && originalEditQty != null && numeric > originalEditQty) {
    //             numeric = originalEditQty;
    //         }

    //         setCurrent(prev => ({
    //             ...prev,
    //             qty: numeric
    //         }));
    //     } else {
    //         setCurrent(prev => ({ ...prev, [field]: e.target.value }));
    //     }
    // };

    const handleChange = field => e => {
        if (field === 'UnitId') {
            const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
            const newUnitId = e.target.value;

            // "Enable Convesrion effect in Transaction?" — only intervene when the config is on
            // and the newly-picked unit differs from this product's own default
            // Unit (current.defaultUnitId, captured at select time). Changing
            // back to the default reverts immediately with no popup (see below).
            if (isApplyRateOnConversionEnabled && current.defaultUnitId && String(newUnitId) !== String(current.defaultUnitId)) {
                setPendingUnitChange({
                    UnitId: newUnitId,
                    unit: selectedUnit ? selectedUnit.unit : '',
                    previousUnitId: current.UnitId,
                });
                // Pre-fill per spec: the product's registered ConvQty only when the
                // newly-picked unit matches the product's registered ConvUnit;
                // otherwise default to 1 (no known ratio for an unrelated unit).
                const matchesConvUnit = current.convUnitId && String(newUnitId) === String(current.convUnitId);
                setConversionQtyInput(matchesConvUnit && current.productConvQty ? String(current.productConvQty) : '1');
                setConversionQtyDialogOpen(true);
                return;
            }

            // Reverting to the product's own default Unit (or config is off) —
            // behave exactly as before, and clear any previously-active conversion.
            setCurrent(prev => ({
                ...prev,
                UnitId: newUnitId,
                unit: selectedUnit ? selectedUnit.unit : '',
                ConversionQty: null,
                ConversionRate: null,
                rate: prev.defaultUnitId && String(newUnitId) === String(prev.defaultUnitId) ? prev.baseRate : prev.rate,
            }));
        } else if (field === 'qty') {
            const newQty = Number(e.target.value) || 0;

            setCurrent(prev => {
                const updated = {
                    ...prev,
                    qty: newQty,

                    // âœ… IMPORTANT: reset old serial/batch selection
                    // configData: newQty !== prev.qty ? [] : prev.configData
                    configData: prev.configData || []
                };
                // Qty shifts the base amount Oth1-7 are computed from — reapply
                // them live here too, same as Disc already does via handleBaseFieldChange.
                return { ...updated, ...recomputeTaxable(updated) };
            });
        } else if (field === 'rate' || field === 'pkg') {
            // Rate/Pkg also shift the base amount Oth1-7 are computed from —
            // reapply them live here too, same as Disc already does via handleBaseFieldChange.
            setCurrent(prev => {
                const updated = { ...prev, [field]: e.target.value };
                return { ...updated, ...recomputeTaxable(updated) };
            });
        }
        else {
            setCurrent(prev => ({
                ...prev,
                [field]: e.target.value
            }));
        }
    };

    // Oth1→Oth7: each one's amount is applied in order on top of the running
    // TaxableAmt (qty*rate*(1-disc/100) as the starting base) — Percentage mode
    // takes its % against the running total so far (not the original base),
    // Rupees mode adds/subtracts a flat value; AddLess=1 means subtract, 0 means add.
    const OTH_FIELDS = [
        { field: 'oth1', col: COL.OTH1 },
        { field: 'oth2', col: COL.OTH2 },
        { field: 'oth3', col: COL.OTH3 },
        { field: 'oth4', col: COL.OTH4 },
        { field: 'oth5', col: COL.OTH5 },
        { field: 'oth6', col: COL.OTH6 },
        { field: 'oth7', col: COL.OTH7 },
    ];
    // Applies Oth1→Oth7 in order on top of `base`, returning both the final
    // taxable amount AND each Oth's own computed rupee contribution (so the
    // disabled "Oth N Amount" field — oth{N}Amt — has something to show in
    // Percentage mode). Used both for the live preview while editing and for
    // the actual Add/Update Product commit, so the two never disagree.
    const applyOthCharges = (base, rowState) => {
        let running = base;
        const amounts = {};
        OTH_FIELDS.forEach(({ field, col }) => {
            const amtField = `${field}Amt`;
            const row = getColRow(col);
            const isRupees = Boolean(row?.RupessToBeAsk);
            const isMinus = Boolean(row?.AddLess);
            // Rupees mode: OthN itself is left 0 in the DB (decimal(5,2), not
            // meant to hold a rupee amount) — the real typed value lives in
            // OthNAmt, so that's the source of truth to read back here too.
            const raw = isRupees ? rowState[amtField] : rowState[field];
            const val = Number(raw);
            if (!raw || Number.isNaN(val) || val === 0) {
                amounts[amtField] = null;
                return;
            }
            const contribution = isRupees ? val : (running * val) / 100;
            // Rupees mode: amtField IS the field the user is actively typing into
            // (othDisplayField routes it there) — reformatting it with toFixed(2)
            // on every keystroke changes the string under the cursor and resets
            // cursor position to the end. Keep the raw typed text as-is; it's only
            // ever Number()'d downstream, so the unformatted string is fine.
            // Percentage mode's amtField is a separate disabled/read-only display,
            // so reformatting it is safe and keeps it looking like a computed amount.
            amounts[amtField] = isRupees ? raw : contribution.toFixed(2);
            running = isMinus ? running - contribution : running + contribution;
        });
        return { taxableAmt: running, amounts };
    };
    // Recomputes base=qty*rate*(1-disc/100) + Oth1→Oth7 from whatever's currently
    // in `updated`, returning the fields to merge back into state. Shared by both
    // the Oth field handler and the Qty/Rate/Disc handlers so TaxableAmt/amount
    // stay Oth-adjusted live, no matter which of the four fields just changed.
    const recomputeTaxable = (updated) => {
        const qty = Number(updated.qty) || 0;
        const rate = Number(updated.rate) || 0;
        const disc = Number(updated.disc) || 0;
        // Use the same Pkg-aware calc as Add Product/handleNext (getAmountCalcSafe)
        // instead of raw qty*rate*(1-disc/100) — otherwise live Oth1-7 typing
        // ignores Pkg*Qty*Rate when "Apply in Amt = Pkg*Qty*Rate?" is enabled.
        const base = getAmountCalcSafe(qty, rate, updated.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
        const { taxableAmt, amounts } = applyOthCharges(base, updated);
        return { ...amounts, TaxableAmt: taxableAmt.toFixed(2), amount: taxableAmt.toFixed(2) };
    };
    // Rupees mode: OthN itself stays 0 in the DB, so the field the user
    // actually types/sees is OthNAmt directly. Percentage mode: the user
    // types the % into OthN, and OthNAmt is the computed, read-only result.
    const othDisplayField = (field, col) => isOthRupeesMode(col) ? `${field}Amt` : field;
    const handleOthChange = (field, col) => (e) => {
        let raw = e.target.value;
        // Numbers only (digits with at most one decimal point) — no letters/special chars
        if (raw !== '' && !/^\d*\.?\d*$/.test(raw)) return;
        if (!isOthRupeesMode(col) && raw !== '') {
            // Percentage mode: clamp to [0, 100]
            const num = Number(raw);
            if (num > 100) raw = '100';
            if (num < 0) raw = '0';
        }
        const targetKey = othDisplayField(field, col);
        setCurrent(prev => {
            const updated = { ...prev, [targetKey]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };
    // Qty/Rate/Disc changing also shifts the base amount Oth1-7 are computed
    // from — reapply them live here too, instead of only on Add/Update Product.
    const handleBaseFieldChange = (field) => (e) => {
        const raw = e.target.value;
        setCurrent(prev => {
            const updated = { ...prev, [field]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };

    // "Enable Convesrion effect in Transaction?" — Confirm applies the pending Unit change plus
    // the Conversion Qty the user entered/accepted, deriving the billed Rate from
    // this row's baseRate (the rate as it stood before any conversion — captured
    // once at product-select time and preserved untouched so it can always be
    // recovered). Cancel reverts the Unit selection back to whatever it was
    // before, so a cancelled popup never leaves the row half-changed.
    const handleConfirmConversionQty = () => {
        if (!pendingUnitChange) return;
        const convQty = Number(conversionQtyInput) || 0;

        if (convQty > 0) {
            const { rate: convertedRate } = calculateConversion(current.baseRate, current.qty, convQty);
            setCurrent(prev => ({
                ...prev,
                UnitId: pendingUnitChange.UnitId,
                unit: pendingUnitChange.unit,
                rate: convertedRate,
                ConversionQty: convQty,
                ConversionRate: prev.baseRate,
            }));
        } else {
            // Invalid/blank conversion qty — treat like Cancel rather than divide by zero.
            setCurrent(prev => ({ ...prev, UnitId: pendingUnitChange.previousUnitId }));
        }

        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };

    const handleCancelConversionQty = () => {
        if (pendingUnitChange) {
            setCurrent(prev => ({ ...prev, UnitId: pendingUnitChange.previousUnitId }));
        }
        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };

    const handleSelect = async product => {

        console.log('🔍 Product selected - Full product object:', product);
        console.log('🔍 Product.MRP:', product.MRP);

        if (product.Id !== current.Id) {
            setModalResetKey(prev => prev + 1);
        }
        const matchedUnit = unitOptions.find(opt => {
            if (product.UnitId && opt.UnitId === product.UnitId) return true;
            if (product.Unit && opt.unit?.toLowerCase() === product.Unit.toLowerCase()) return true;
            if (product.unit && opt.unit?.toLowerCase() === product.unit.toLowerCase()) return true;
            return false;
        });
        // Qty is left empty on item select — the user types it ('' * rate = 0, so amounts start at 0.00).
        const qty = '';
        let rate = Number(product.Rate) || 0;
        let disc = Number(product.Discount) || 0;
        let MRP = Number(product.MRP) || '';
        console.log('💰 MRP value extracted:', MRP);

        // "Show Item List Partywise in Sale?" — when enabled, this item's Rate/Disc
        // must come strictly from partywiserate for this party, with NO fallback to
        // productmaster's saleRate/SaleDisc.
        if (isShowItemListPartywiseInSaleEnabled && clientData?.clientId) {
            const partywiseData = await getPartywiseRate(product.Id, clientData.clientId);
            if (partywiseData.found) {
                rate = partywiseData.saleRate !== null ? partywiseData.saleRate : 0;
                disc = partywiseData.disc !== null ? partywiseData.disc : 0;
                console.log('✅ Invoice_Steeper: Rate/Disc taken from partywiserate (no productmaster fallback):', rate, disc);
            }
        }

        // Fetch last sale rate if enabled
        console.log('📦 Invoice_Steeper: Product selected, checking if last sale rate should be fetched');
        if (isLastSaleRateEnabled) {
            console.log('💾 Invoice_Steeper: Fetching last sale rate for product:', product.Id, 'party:', clientData?.clientId);
            const lastSaleData = await getLastSaleRate(product.Id, clientData.clientId);
            if (lastSaleData.rate !== null) {
                rate = lastSaleData.rate;
                console.log('✅ Invoice_Steeper: Last sale rate fetched:', rate);
            }
            if (lastSaleData.disc !== null) {
                disc = lastSaleData.disc;
                console.log('✅ Invoice_Steeper: Last sale disc fetched:', disc);
            }
        }

        // First try to get tax from product.GST
        const productTax = parseFloat(product.GST) || 0;

        // Try to find GST by TaxId first
        let matchedGST = gsts.find(g => String(g.Id) === String(product.TaxId));

        // If no match by TaxId, try to find by matching tax percentage
        if (!matchedGST && productTax >= 0) {
            matchedGST = gsts.find(g => getTaxPercent(g.value) === productTax);
        }

        const tax = matchedGST ? getTaxPercent(matchedGST.value) : productTax;
        const taxId = matchedGST ? matchedGST.Id : product.TaxId || null;

        // If "Apply MRP in Sale?" is enabled and product has MRP, calculate rate from MRP
        if (isApplyMRPInSaleEnabled && MRP > 0) {
            console.log('🏷️ Invoice_Steeper: Apply MRP in Sale enabled. Calculating rate from MRP:', MRP);
            rate = calculateSaleRateFromMRP(MRP, tax);
            console.log('✅ Invoice_Steeper: Rate calculated from MRP:', rate);
        }

        // "Apply Partywise/Price-listwise Disc. in Sale?" — if the item has a
        // price-list entry, use its NewPrice as the Rate; otherwise the existing
        // productmaster-based rate above is left untouched.
        if (isApplyPartywisePriceListDiscInSaleEnabled) {
            const priceListData = await getPriceListRate(product.Id);
            if (priceListData.found && priceListData.newPrice !== null) {
                rate = priceListData.newPrice;
                console.log('✅ Invoice_Steeper: Rate taken from pricelistdetails:', rate);
            }

            // Disc now comes from groupwisedisc (matched by this item's ItemGrpId for
            // this party), not clientmaster. If there's no matching group-wise entry,
            // Disc is 0.00 — no fallback to clientmaster or productmaster.
            if (clientData?.clientId) {
                const groupDiscData = await getGroupWiseDisc(product.Id, clientData.clientId);
                disc = groupDiscData.found && groupDiscData.disc !== null ? groupDiscData.disc : 0;
                console.log('✅ Invoice_Steeper: Disc taken from groupwisedisc (no fallback):', disc);
            }
        }

        // "Disc Scheme" — only when this book's Oth1 AND Oth2 are both enabled,
        // Percentage (not Rupees) and minus (AddLess): fill Oth1 = clientmaster.Disc1,
        // Oth2 = clientmaster.Disc2 (empty/null -> 0).
        // Disc field itself is also taken from clientmaster.Disc whenever Disc Scheme is on.
        let discSchemeOth = null;
        if (isDiscSchemeEnabled && clientData?.clientId) {
            const scheme = await getClientDiscScheme(clientData.clientId);
            disc = scheme.disc || 0;
            console.log('✅ Invoice_Steeper: Disc taken from clientmaster (Disc Scheme):', disc);
            // Oth1 and Oth2 are checked independently: each is filled only if it is
            // enabled, Percentage (not Rupees) and minus (AddLess).
            const oth1Qualifies = isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && Boolean(getColRow(COL.OTH1)?.AddLess);
            const oth2Qualifies = isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && Boolean(getColRow(COL.OTH2)?.AddLess);
            if (oth1Qualifies || oth2Qualifies) {
                discSchemeOth = {
                    oth1: oth1Qualifies ? String(scheme.disc1 || 0) : '',
                    oth2: oth2Qualifies ? String(scheme.disc2 || 0) : '',
                };
            }
        }

        const taxableAmt = qty * rate * (1 - disc / 100);
        const taxAmount = taxableAmt * (tax / 100);

        setCurrent({
            Id: product.Id?.toString() || '',
            productCode: product.itemCode || '',
            description: product.description || '',
            UnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
            unit: matchedUnit ? matchedUnit.unit : '',
            qty,
            rate,
            disc,
            tax,
            MRP,
            batchNo: '',
            expDate: '',
            serialNo: '',
            amount: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            remark: '',
            TaxId: taxId,
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            UTGST: '0.00',
            GSTCess: '0.00',
            GSTCEssAmt: '0.00',
            GSTOth: '0.00',
            GSTEduCess: '0.00',
            GSTEducessAmt: '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
            TaxableAmt: taxableAmt.toFixed(2),
            challanDtsID: null,
            challanID: null,
            qoutID: null,
            qoutDtsID: null,
            piId: null,
            piDtsID: null,
            soId: null,
            soDtsID: null,
            PONo: '',
            PODate: '',
            poQty: '',
            type: '',
            size: '',
            color: '',
            freeQty: '',
            per: '',
            pkg: '',
            oth1: discSchemeOth ? discSchemeOth.oth1 : '',
            oth2: discSchemeOth ? discSchemeOth.oth2 : '',
            oth3: '',
            oth4: '',
            oth5: '',
            oth6: '',
            oth7: '',
            ex4: '',
            ex5: '',
            exQty6: '',
            serialNo: '',
            configData: [],
            // "Enable Convesrion effect in Transaction?" — captured from productmaster at select
            // time; no conversion is active yet on a freshly-selected row.
            defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
            convUnitId: product.ConvUnit ? String(product.ConvUnit) : '',
            productConvQty: Number(product.ConvQty) || '',
            baseRate: rate,
            ConversionQty: null,
            ConversionRate: null
        });

        // Reapply Oth1-7 on the fresh row so Oth1/Oth2 Amount and TaxableAmt reflect the Disc Scheme.
        if (discSchemeOth) {
            setCurrent(prev => ({ ...prev, ...recomputeTaxable(prev) }));
        }

        setTrackingConfig({
            applyBatchNo: product.ApplyBatchNo || 0,
            applySerialNo: product.ApplySerialNo || 0,
            expiryDays: product.ExpiryDays || 0,
            warrantyMonths: product.WarrantyMonths || 0
        });
        // setEditIndex(null);
        setErrors({});
    };


    // const getExistingBatchSelections = () => {

    //     const map = {};

    //     rows.forEach((row, index) => {

    //         if (editIndex !== null && index === editIndex) return;

    //         if (Number(row.productId) !== Number(current.Id)) return;

    //         (row.configData || []).forEach(batch => {

    //             const batchNo = batch.value;

    //             const selectedQty =
    //                 Number(batch.is_selected) === 1
    //                     ? Number(batch.selected_qty || 0)
    //                     : 0;

    //             map[batchNo] =
    //                 (map[batchNo] || 0) + selectedQty;
    //         });
    //     });

    //     console.log("FINAL MAP", map);

    //     return map;
    // };

    //updated function for not showing selected serials in new product
    const getExistingBatchSelections = () => {

        const map = {};

        rows.forEach((row, index) => {

            // skip current editing row
            if (editIndex !== null && index === editIndex) return;

            // same product only
            if (Number(row.productId) !== Number(current.Id)) return;

            (row.configData || []).forEach(item => {

                const key = item.value;

                // SERIAL
                if (row.applySerialNo === 1) {

                    if (Number(item.is_selected) === 1) {
                        map[key] = 1;
                    }

                    return;
                }

                // BATCH
                const selectedQty =
                    Number(item.is_selected) === 1
                        ? Number(item.selected_qty || 0)
                        : 0;

                map[key] =
                    (map[key] || 0) + selectedQty;
            });
        });

        return map;
    };

    // const isChallanLocked = useMemo(() => {
    //     if (!Array.isArray(initialData?.tableData)) return false;

    //     return initialData.tableData.some(
    //         row => row?.challanID != null || row?.challanDtsID != null
    //     );
    // }, [initialData?.tableData]);

    const isChallanLocked = useMemo(() => {
        if (mode === 'ref') return true;
        if (creditNoteExists) return true;

        if (!Array.isArray(rows)) return false;

        return rows.some(
            r => r?.challanID != null || r?.challanDtsID != null || r?.qoutDtsID != null || r?.piDtsID != null || r?.soDtsID != null
        );
    }, [rows, mode, creditNoteExists]);

    const addProduct = async () => {

        // Allow updates in ref mode, but prevent adding new products
        if (isChallanLocked && !(mode === 'ref' && editIndex !== null)) return;

        // In ref mode, skip validation if not editing a row
        if (mode === 'ref' && editIndex == null) return;

        const errs = {};
        const messages = new Set();
        const requiredFields = ['productCode', 'description', 'UnitId', 'qty', 'rate', 'tax'];

        requiredFields.forEach(field => {
            if (!current[field] && current[field] !== 0) {
                errs[field] = 'Required';
                messages.add('All fields are required.');
            }
        });

        console.log("configData at validation:", JSON.stringify(current.configData, null, 2));
        console.log("trackingConfig:", trackingConfig);
        console.log("current.qty:", current.qty);


        // TRACKING VALIDATION
        if (
            (trackingConfig.applySerialNo === 1 || trackingConfig.applyBatchNo === 1) &&
            (!current.configData || current.configData.length === 0)
        ) {
            setErrors({
                ...errs,
                global: ["Please add Serial / Batch details"]
            });
            return;
        }

        const isTracking =
            (trackingConfig.applySerialNo === 1 ||
                trackingConfig.applyBatchNo === 1) &&
            Array.isArray(current.configData);

        if (isTracking) {
            let totalTrackingQty = 0;

            // if (trackingConfig.applySerialNo === 1) {
            //     totalTrackingQty = current.configData.filter(item =>
            //         Number(item.is_selected) === 1 ||
            //         item.is_selected === undefined  // ADD mode: all entries are selected
            //     ).length;
            // } else {
            //     totalTrackingQty = current.configData.reduce(
            //         (sum, item) => sum + (Number(item.selected_qty) || Number(item.qty) || 0),
            //         0
            //     );
            // }

            if (trackingConfig.applySerialNo === 1) {
                totalTrackingQty = current.configData.filter(item =>
                    Number(item.is_selected) === 1
                ).length;
            } else {
                totalTrackingQty = current.configData.reduce(
                    (sum, item) => sum + (Number(item.selected_qty) || 0),
                    0
                );
            }

            const productQty = Number(current.qty) || 0;

            if (totalTrackingQty !== productQty) {
                setErrors({
                    ...errs,
                    global: [`Product Qty (${productQty}) must match Serial/Batch Total (${totalTrackingQty})`]
                });
                return;
            }
        }


        //GST validation
        if (!current.TaxId) {
            errs.TaxId = true;
            messages.add('Please select GST before adding product.');
        }

        if (!current.qty || Number(current.qty) <= 0) {
            errs.qty = 'Must be > 0';
            messages.add('Qty must be greater than 0');
        }

        if (!current.rate || Number(current.rate) <= 0) {
            errs.rate = 'Rate must be greater than 0';
            messages.add('Rate must be greater than 0');
        }

        if (current.disc < 0) {
            errs.disc = 'Cannot be negative';
            messages.add('Discount cannot be negative');
        }

        if (current.disc > 100) {
            errs.disc = 'Cannot be more than 100';
            messages.add('Discount cannot be more than 100');
        }

        if (messages.size > 0) {
            errs.global = Array.from(messages);
            setErrors(errs);
            return;
        }

        const qty = Number(current.qty) || 0;

        // Negative/Zero Stock validation check - block if negative/zero and configure is enabled
        console.log('🚫 Invoice_Steeper: Checking if product has negative or zero stock');
        const zeroStockValidation = await validateNegativeZeroStock(current.Id);
        console.log('🚫 Invoice_Steeper: Zero stock validation result:', zeroStockValidation);

        if (zeroStockValidation.isBlocked) {
            console.log('❌ Invoice_Steeper: Product is blocked - stock is zero or negative');
            setZeroStockErrorData(zeroStockValidation);
            setZeroStockErrorOpen(true);
            return;
        }

        if (zeroStockValidation.shouldShowWarning) {
            console.log('⚠️ Invoice_Steeper: Showing zero stock warning - user can choose to add anyway');
            const confirmed = await new Promise((resolve) => {
                setZeroStockErrorData(zeroStockValidation);
                setZeroStockErrorOpen(true);
                setStockConfirmResolve(() => resolve);
            });
            console.log('✅ Invoice_Steeper: User response to zero stock warning:', confirmed);
            if (!confirmed) {
                console.log('❌ Invoice_Steeper: User cancelled - not adding product');
                return;
            }
            console.log('✅ Invoice_Steeper: User chose to add anyway - proceeding');
        } else {
            console.log('✅ Invoice_Steeper: No zero stock warning needed - proceeding');
        }

        // Min Level Stock validation check
        console.log('📋 Invoice_Steeper: About to validate min level stock for item:', { itemId: current.Id, qty, L_No });
        const stockValidation = await validateMinLevel(current.Id, qty, L_No);
        console.log('📊 Invoice_Steeper: Stock validation result:', stockValidation);

        if (stockValidation.shouldShowWarning) {
            console.log('⚠️ Invoice_Steeper: Showing min level stock warning dialog');
            const confirmed = await new Promise((resolve) => {
                setStockWarningData(stockValidation);
                setStockConfirmResolve(() => resolve);
                setStockWarningOpen(true);
            });
            console.log('✅ Invoice_Steeper: User response to min level warning:', confirmed);
            if (!confirmed) {
                console.log('❌ Invoice_Steeper: User cancelled - not adding product');
                return;
            }
        } else {
            console.log('✅ Invoice_Steeper: No min level stock warning needed - proceeding');
        }

        const safeDisc =
            current.disc === '' || current.disc == null
                ? 0
                : Number(current.disc);
        const rate = Number(current.rate) || 0;
        const pkg = Number(current.pkg) || 0;  // Get package value (0 treated as 1)
        // const disc = Number(current.disc) || 0;
        const disc = safeDisc || 0;
        const tax = Number(current.tax) || 0;

        // ✅ Use calculateAmount function which respects isApplyPkgInAmtEnabled
        const amountCalc = getAmountCalcSafe(qty, rate, current.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount);
        // Oth1→Oth7 are applied on top of this base TaxableAmt before the row is committed,
        // so Add/Update Product always carries the Oth-adjusted amount, not the raw base.
        const { taxableAmt, amounts: othAmounts } = applyOthCharges(amountCalc.taxable, current);
        const taxAmount = taxableAmt * (tax / 100);

        console.log('💰 Add Product - Amount calculation:', { qty, rate, pkg, disc, isApplyPkgInAmtEnabled, taxableAmt });

        const row = {
            ...current,
            ...othAmounts,
            _isNew: true,
            configData: (current.configData || []).map(item => ({
                ...item,
                value: item.value || item.SerialNo || item.BatchNo || ''
            })),
            productId: current.Id,
            // configData: current.configData || [],
            configType:
                trackingConfig.applySerialNo === 1
                    ? "serial"
                    : trackingConfig.applyBatchNo === 1
                        ? "batch"
                        : null,
            applyBatchNo: trackingConfig.applyBatchNo,
            applySerialNo: trackingConfig.applySerialNo,
            warrantyMonths: current.warrantyMonths || null,
            expiryDays: current.expiryDays || null,
            qty,
            rate,
            disc,
            tax,
            remark: current.remark || '',
            TaxableAmt: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            amount: taxableAmt.toFixed(2),
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
            UTGST: current.UTGST,
            GSTCess: current.GSTCess,
            TaxId: current.TaxId,
            srNo: editIndex != null ? rows[editIndex].srNo : nextSrNo,
            challanDtsID: editIndex != null ? rows[editIndex].challanDtsID : null,
            challanID: editIndex != null ? rows[editIndex].challanID : null,
            qoutID: editIndex != null ? rows[editIndex].qoutID : null,
            qoutDtsID: editIndex != null ? rows[editIndex].qoutDtsID : null,
            piId: editIndex != null ? rows[editIndex].piId : null,
            piDtsID: editIndex != null ? rows[editIndex].piDtsID : null,
            soId: editIndex != null ? rows[editIndex].soId : null,
            soDtsID: editIndex != null ? rows[editIndex].soDtsID : null
        };

        const existingRowIndex = rows.findIndex(
            (r, i) => r.productCode === current.productCode && i !== editIndex
        );

        // if (existingRowIndex !== -1 && editIndex == null) {
        //     setRows(prev =>
        //         prev.map((r, i) => {
        //             if (i === existingRowIndex) {
        //                 const newQty = Number(r.qty) + qty;
        //                 const newTaxableAmt = newQty * rate * (1 - disc / 100);
        //                 const newTaxAmount = newTaxableAmt * (tax / 100);
        //                 return {
        //                     ...r,
        //                     qty: newQty,
        //                     rate,
        //                     disc,
        //                     tax,
        //                     remark: current.remark || r.remark,
        //                     TaxableAmt: newTaxableAmt.toFixed(2),
        //                     taxAmount: newTaxAmount.toFixed(2),
        //                     amount: newTaxableAmt.toFixed(2),
        //                     CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
        //                     SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
        //                     IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
        //                     CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
        //                     SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
        //                     IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? newTaxAmount.toFixed(2) : '0.00',
        //                     UTGST: current.UTGST,
        //                     GSTCess: current.GSTCess,
        //                     TaxId: current.TaxId,
        //                     challanDtsID: r.challanDtsID,
        //                     challanID: r.challanID,
        //                     soId: r.soId,
        //                     soDtsID: r.soDtsID
        //                 };
        //             }
        //             return r;
        //         })
        //     );
        // } else {
        //     if (editIndex != null) {
        //         setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
        //     } else {
        //         setRows(prev => [row, ...prev]);
        //         setNextSrNo(prev => prev + 1);
        //     }
        // }

        if (editIndex != null) {
            if (editIndex != null) {
                setRows(prev =>
                    prev.map((r, i) =>
                        i === editIndex ? { ...row, srNo: prev[i].srNo, _isNew: true } : r  // â† preserve _isNew on edit too
                    )
                );
            }
        } else {
            setRows(prev => [row, ...prev]);
            setNextSrNo(prev => prev + 1);
        }



        setIsEditingMode(false);
        setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, MRP: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, refNo: '', refDate: '', refQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', gOth10: '0.00' });
        setErrors({});
        setEditIndex(null);
        // setOriginalEditQty(null);

        // Focus on Product Code field after adding product (not after updating)
        if (editIndex == null) {
            setTimeout(() => {
                productCodeRef.current?.focus?.();
            }, 0);
        }
    };

    const editRow = idx => {

        // if (isChallanLocked) return;

        const row = rows[idx];
        console.log("editRow configData[0]:", JSON.stringify(row.configData?.[0]));
        const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(row.UnitId)) ||
            unitOptions.find(u => String(u.UnitId) === String(row.unit)) ||
            unitOptions.find(u => u.unit?.toLowerCase() === String(row.unit).toLowerCase());

        // This row's Qty/Rate/Pkg/Disc are about to be loaded into `current` from
        // the DB values — skip the next live-calculation pass so it doesn't
        // immediately overwrite the stored amount before the user edits anything.
        skipNextCalcRef.current = true;

        setCurrent({
            ...row,
            Id: row.productId,
            UnitId: matchedUnit ? String(matchedUnit.UnitId) : row.UnitId || '',
            unit: matchedUnit ? matchedUnit.unit : row.unit || '',
            MRP: row.MRP || '',
            CGST: String(row.CGST || '0.00'),
            SGST: String(row.SGST || '0.00'),
            IGST: String(row.IGST || '0.00'),
            CGSTAmt: String(row.CGSTAmt || '0.00'),
            SGSTAmt: String(row.SGSTAmt || '0.00'),
            IGSTAmt: String(row.IGSTAmt || '0.00'),
            UTGST: String(row.UTGST || '0.00'),
            GSTCess: String(row.GSTCess || '0.00'),
            TaxableAmt: String(row.TaxableAmt || '0.00'),
            taxAmount: String(row.taxAmount || '0.00'),
            amount: String(row.amount || '0.00'),
            TaxId: row.TaxId ?? null,          // âœ… Use ?? instead of ||
            tax: row.tax ?? 0,
            challanDtsID: row.challanDtsID || null,
            challanID: row.challanID || null,
            soId: row.soId || null,
            soDtsID: row.soDtsID || null,
            srNo: row.srNo,
            configData: (row.configData || []).map(item => ({
                ...item,
                id: Number(item.id),
                is_selected: Number(item.is_selected ?? 0),
                selected_qty: Number(item.selected_qty ?? item.qty ?? 0),
                available_qty: Number(item.available_qty ?? 0),
                display_qty: item.display_qty != null
                    ? Number(item.display_qty)
                    : undefined,
                qty: Number(item.qty ?? 1)
            }))
        });
        setTrackingType(row.configType);
        setTrackingConfig({
            applyBatchNo: row.applyBatchNo || 0,
            applySerialNo: row.applySerialNo || 0,
            expiryDays: row.expiryDays || 0,
            warrantyMonths: row.warrantyMonths || 0
        });
        setEditIndex(idx);
        // setOriginalEditQty(Number(row.qty) || 0);
        setIsEditingMode(true);
    };

    const deleteRow = idx => {
        setRows(prev => prev.filter((_, i) => i !== idx));
        if (idx === editIndex) {
            setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, MRP: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, refNo: '', refDate: '', refQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', gOth10: '0.00' });
            setEditIndex(null);
            setErrors({});
            // setOriginalEditQty(null);
            setIsEditingMode(false);
        }
    };




    const handleNext = async () => {

        console.log("")
        if (rows.length === 0) {
            setErrors({ global: 'Add at least one product' });
            return;
        }

        // Check credit limit if feature is enabled - BLOCK bill creation if limit exceeded (no override)
        if (isDontMakeSaleInvoiceIfLimitOverEnabled && clientData?.clientId) {
            console.log('🔍 handleNext: Validating credit limit for clientId:', clientData.clientId, 'Current Bill Amount:', totals.total);
            const creditLimitValidation = await validateCreditLimit(clientData.clientId, totals.total);
            console.log('📊 handleNext: Credit limit validation result:', creditLimitValidation);

            if (creditLimitValidation.shouldShowWarning) {
                // BLOCK bill creation completely - no override option
                const billAmount = Number(totals.total) || 0;
                const creditLimit = Number(creditLimitValidation.creditLimit) || 0;
                const outstanding = Number(creditLimitValidation.outstandingAmount) || 0;
                const totalAmount = Number(creditLimitValidation.totalAmount) || 0;
                const exceedBy = totalAmount - creditLimit;

                setErrorDialog({
                    open: true,
                    type: 'creditLimit',
                    creditLimitData: {
                        firmName: creditLimitValidation.firmName || clientData?.clientName || 'Client',
                        creditLimit: creditLimit.toFixed(2),
                        outstandingAmount: outstanding.toFixed(2),
                        currentBillAmount: billAmount.toFixed(2),
                        totalAmount: totalAmount.toFixed(2),
                        exceedAmount: exceedBy.toFixed(2)
                    }
                });
                return;
            }
        }

        // Check that all products have rate > 0 (double safety check for ref mode)
        if (mode === 'ref') {

            const productsWithZeroRate = rows.filter(r => Number(r.rate) <= 0);
            if (productsWithZeroRate.length > 0) {
                const productCodes = productsWithZeroRate.map(r => r.productCode).join(', ');
                setErrors({ global: `Rate must be greater than 0 for product(s): ${productCodes}` });
                return;
            }

        }
        if (tcsEnabled) {
            const percent = Number(tcsPercent);

            if (!tcsPercent || percent <= 0) {
                setErrors({ global: 'TCS % is required' });
                return;
            }

            if (isNaN(percent)) {
                setErrors({ global: 'Invalid TCS %' });
                return;
            }

            if (percent > 100) {
                setErrors({ global: 'TCS % cannot exceed 100' });
                return;
            }

            // if (!/^\d+(\.\d{1,2})?$/.test(tcsPercent)) {
            //     setErrors({ global: 'TCS % allows max 2 decimal places' });
            //     return;
            // }
        }

        console.log("rows", rows)

        if (isTrackingEnabled) {

            const productMap = {};

            // â”€â”€â”€â”€â”€â”€â”€â”€â”€ BUILD MAP â”€â”€â”€â”€â”€â”€â”€â”€â”€
            rows.forEach(r => {
                if (!r.configData?.length) return;

                const productId = String(r.productId);
                const productCode = r.productCode;

                if (!productMap[productId]) {
                    productMap[productId] = {
                        productCode,
                        serials: {},   // serial tracking
                        batches: {}    // batch tracking
                    };
                }

                // â”€â”€â”€â”€â”€ SERIAL â”€â”€â”€â”€â”€
                if (r.configType === "serial") {
                    r.configData.forEach(item => {
                        // âœ… ONLY count if explicitly selected
                        if (Number(item.is_selected) !== 1) return;

                        const serialNo = String(item.value || item.SerialNo || "").trim();
                        if (!serialNo) return;

                        if (!productMap[productId].serials[serialNo]) {
                            productMap[productId].serials[serialNo] = 0;
                        }

                        productMap[productId].serials[serialNo] += 1;
                    });
                }

                // â”€â”€â”€â”€â”€ BATCH â”€â”€â”€â”€â”€
                if (r.configType === "batch") {

                    r.configData.forEach(item => {

                        const id = Number(item.id ?? item.StockAutoId);
                        const batchNo = item.value || item.BatchNo;

                        // const available = Number(
                        //     item.display_qty ?? item.available_qty ?? 0
                        // );

                        //recent change modiied existing code

                        console.log("configData item", item);
                        const available = Number(
                            item.actual_stock ?? item.display_qty ?? item.available_qty ?? 0
                        );

                        // console.log("avialable" , available)

                        // const selected = Number(item.selected_qty || item.qty || 0);
                        // const selected =
                        //     Number(item.is_selected) === 1
                        //         ? Number(item.selected_qty ?? item.qty ?? 0)
                        //         : 0;

                        //recent change modified the existing code
                        const isSelected =
                            item.is_selected !== undefined
                                ? Number(item.is_selected) === 1
                                : Number(item.selected_qty || 0) > 0;

                        const selected = isSelected
                            ? Number(item.qty ?? item.selected_qty ?? 0)
                            : 0;


                        // console.log("selected", selected)

                        if (!productMap[productId].batches[id]) {
                            productMap[productId].batches[id] = {
                                batchNo,
                                selected: 0,
                                available
                            };
                        }

                        productMap[productId].batches[id].selected += selected;

                        //recent change added new code
                        productMap[productId].batches[id].available = Math.max(
                            productMap[productId].batches[id].available,
                            available
                        );

                    });
                }

            });

            console.log("productMap", productMap)


            // â”€â”€â”€â”€â”€â”€â”€â”€â”€ VALIDATION â”€â”€â”€â”€â”€â”€â”€â”€â”€
            const errors = [];

            Object.values(productMap).forEach(p => {

                // â”€â”€â”€ SERIAL VALIDATION (ONLY DUPLICATE) â”€â”€â”€
                const serialErrors = Object.entries(p.serials).filter(
                    ([_, count]) => count > 1
                );

                if (serialErrors.length > 0) {
                    errors.push({
                        // summary: `${p.productCode}`,
                        // details: serialErrors.map(([serial, count]) =>
                        //     `${serial} (selected: ${count})`
                        // ).join(", ")
                        summary: `item code : ${p.productCode}`,
                        details:
                            `serials : ` +
                            serialErrors.map(([serial, count]) =>
                                `${serial} (selected: ${count})`
                            ).join(", ")
                    });
                }

                // â”€â”€â”€ BATCH VALIDATION (QTY EXCEED) â”€â”€â”€
                const batchErrors = Object.values(p.batches).filter(
                    b => b.selected > b.available
                );



                if (batchErrors.length > 0) {
                    errors.push({
                        // summary: `${p.productCode}`,
                        // details: batchErrors.map(b =>
                        //     `${b.batchNo} (selected: ${b.selected}, available: ${b.available})`
                        // ).join(", ")
                        summary: `item code : ${p.productCode}`,
                        details:
                            `batches : ` +
                            batchErrors.map(b =>
                                `${b.batchNo} (selected: ${b.selected}, available: ${b.available})`
                            ).join(", ")
                    });
                }
            });

            // â”€â”€â”€â”€â”€â”€â”€â”€â”€ SHOW ERROR â”€â”€â”€â”€â”€â”€â”€â”€â”€
            if (errors.length > 0) {
                setSnackbar({
                    open: true,
                    severity: "error",
                    details: errors
                });
                return;
            }
        }
        // â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

        const isSameState = state?.toLowerCase() === compState?.toLowerCase();

        console.log("SelectedAdvanceRows", selectedAdvanceRows)

        const payloadRows = rows.map(r => {
            const qty = Number(r.qty) || 0;
            const rate = Number(r.rate) || 0;
            const pkg = Number(r.pkg) || 0;  // Get package from row, default to 0 (will be treated as 1 in calculation)
            const disc = Number(r.disc) || 0;

            // Use calculateAmount function which respects isApplyPkgInAmtEnabled configuration
            const amountCalc = getAmountCalcSafe(qty, rate, r.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount);
            const gross = amountCalc.gross;
            // Oth1→Oth7 are re-applied on top of the base taxable amount here too,
            // so the final submit payload always carries the Oth-adjusted amount
            // (matches what Add/Update Product already computed) instead of silently
            // reverting to the raw qty*rate*disc base.
            const { taxableAmt: taxable, amounts: othAmountsFinal } = applyOthCharges(amountCalc.taxable, r);

            // Disc% is against gross only — independent of any Oth1-7
            // adjustment baked into `taxable`, which is the final amount.
            const discAmt = gross * (disc / 100);
            const taxPct = Number(r.tax) || 0;
            const taxAmt = Number(r.taxAmount) || (taxable * (taxPct / 100));

            const cgstAmt = (r.CGSTAmt != null && r.CGSTAmt !== '') ? Number(r.CGSTAmt) : (isSameState ? taxAmt / 2 : 0);
            const sgstAmt = (r.SGSTAmt != null && r.SGSTAmt !== '') ? Number(r.SGSTAmt) : (isSameState ? taxAmt / 2 : 0);
            const igstAmt = (r.IGSTAmt != null && r.IGSTAmt !== '') ? Number(r.IGSTAmt) : (isSameState ? 0 : taxAmt);

            // build backend-ready configData
            const configData = (() => {
                const data = r.configData || [];
                if (data.length === 0) return [];

                if (r.configType === "serial") {
                    // filter only selected, map to backend format
                    return data
                        .filter(item =>
                            Number(item.is_selected) === 1 ||   // backend format
                            item.value != null && item.is_selected === undefined  // add mode format (all entries are selected)
                        )
                        .map(item => ({
                            ...item,
                            value: item.value || item.SerialNo,
                            qty: 1
                        }));
                }

                if (r.configType === "batch") {
                    return data
                        .filter(item =>
                            Number(item.is_selected) === 1 &&
                            Number(item.selected_qty) > 0
                        )
                        .map(item => ({
                            ...item,
                            value: item.value || item.BatchNo,
                            qty: Number(item.selected_qty) || 0,
                            expiryDate: item.expiryDate || item.ExpiryDate || null  // â† add this
                        }));
                }

                return data;
            })();

            // console.log("configData" , configData)
            return {
                ...r,
                ...othAmountsFinal,
                configData,
                productId: r.productId,
                productCode: r.productCode,
                description: r.description,
                unit: r.unit,
                UnitId: Number(r.UnitId) || null,
                qty: mode === 'ref'
                    ? Number(r.dispQty ?? r.qty) || 0
                    : Number(r.qty) || 0,
                rate,
                // "Enable Convesrion effect in Transaction?" — ConversionQty/ConversionRate mirror
                // saleinvoicedetails' columns 1:1 (null on a normal, non-converted
                // row). stockQty is the base-unit-equivalent quantity to post to
                // stockinout's StockInQty/StockOutQty; it equals qty/ConversionQty
                // when a conversion is active on this row, otherwise the plain qty.
                ConversionQty: r.ConversionQty != null ? Number(r.ConversionQty) : null,
                ConversionRate: r.ConversionRate != null ? Number(r.ConversionRate) : null,
                stockQty: r.ConversionQty
                    ? Number(((Number(r.qty) || 0) / Number(r.ConversionQty)).toFixed(2))
                    : Number(r.qty) || 0,
                MRP: Number(r.MRP) || 0,
                disc: Number(r.disc) || 0,
                tax: taxPct,
                batchNo: r.batchNo || '',
                expDate: r.expDate || null,
                serialNo: r.serialNo || '',
                remark: r.remark || '',
                gross: Number(gross.toFixed(2)),
                amount: Number(taxable.toFixed(2)),
                DiscAmt: Number(discAmt.toFixed(2)),
                taxAmount: Number(taxAmt.toFixed(2)),
                srNo: r.srNo,
                TaxId: r.TaxId || null,
                CGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
                SGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
                IGST: isSameState ? 0 : Number(taxPct.toFixed(2)),
                CGSTAmt: Number(cgstAmt.toFixed(2)),
                SGSTAmt: Number(sgstAmt.toFixed(2)),
                IGSTAmt: Number(igstAmt.toFixed(2)),
                UTGST: r.UTGST || '0.00',
                GSTCess: r.GSTCess || '0.00',
                GSTCEssAmt: r.GSTCEssAmt || '0.00',
                GSTOth: r.GSTOth || '0.00',
                GSTEduCess: r.GSTEduCess || '0.00',
                GSTEducessAmt: r.GSTEducessAmt || '0.00',
                refNo: r.refNo || null,
                refDate: r.refDate || null,
                refQty: r.refQty || null,
                PONo: r.PONo || null,
                PODate: r.PODate || null,
                poQty: r.poQty || null,
                type: r.type || null,
                size: r.size || null,
                color: r.color || null,
                freeQty: r.freeQty || null,
                per: r.per || null,
                pkg: r.pkg || null,
                oth1: r.oth1 || null,
                oth1Amt: r.oth1Amt || null,
                oth2: r.oth2 || null,
                oth2Amt: r.oth2Amt || null,
                oth3: r.oth3 || null,
                oth3Amt: r.oth3Amt || null,
                oth4: r.oth4 || null,
                oth4Amt: r.oth4Amt || null,
                oth5: r.oth5 || null,
                oth5Amt: r.oth5Amt || null,
                oth6: r.oth6 || null,
                oth6Amt: r.oth6Amt || null,
                oth7: r.oth7 || null,
                oth7Amt: r.oth7Amt || null,
                ex4: r.ex4 || null,
                ex5: r.ex5 || null,
                exQty6: r.exQty6 || null,
                challanDtsID: r.challanDtsID || null,
                challanID: r.challanID || null,
                soId: r.soId || null,
                soDtsID: r.soDtsID || null
            };
        });

        // Validate advance payment amount
        const billAmt = Number(totals.total || 0);
        const advanceAmt = Number(adjustAmt || 0);

        if (adjustAdvancePayment && advanceAmt > 0 && billAmt < advanceAmt) {
            setErrors({ global: 'You have to remove the Advance Payment. Bill amount cannot be less than advance payment amount.' });
            return;
        }

        // Additional Charges: charges saved in UserDefineColumns with ColToBeAsk=1
        // (i.e. present in `additionalCharges`, sourced from UserDefineContext) are
        // folded into the invoice payload — Adc{SrNo}Amt/Adc{SrNo}TaxId in summary
        // for all 5 fixed slots, plus one pseudo item row per SELECTED charge
        // (TransType 200-204, SrNo 20000-20004) appended to tableData.
        // When a charge's Tax is disabled, its TaxId is resolved to the taxmaster
        // row where GST = 0 (found via gsts, whose `value` doubles as the % — same
        // pattern already used elsewhere in this file, e.g. parseFloat(opt.value)).
        const zeroTaxId = gsts.find(g => parseFloat(g.value) === 0)?.Id ?? null;

        const additionalChargeSummary = {};
        const additionalChargeItems = [];
        for (let slot = 1; slot <= 5; slot++) {
            const charge = additionalCharges.find(c => Number(c.SrNo) === slot);
            if (!charge) {
                additionalChargeSummary[`Adc${slot}Amt`] = 0;
                additionalChargeSummary[`Adc${slot}TaxId`] = null;
                continue;
            }
            const key = charge.TransType;
            const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
            // Ensure taxId is always populated: use input.taxId if set, otherwise use charge.TaxId
            const inputWithDefaults = {
                amount: input.amount || '',
                taxId: input.taxId ?? charge.TaxId ?? null
            };
            const { taxPercent, taxAmount, finalAmount } = getChargeFinalAmounts(charge, inputWithDefaults);
            const amount = Number(inputWithDefaults.amount) || 0;
            // Always send taxId from frontend (from chargeInputs or default to charge.TaxId)
            const taxId = inputWithDefaults.taxId;

            // saleinvoicemaster.AdcNAmt stores the charge's own pre-tax amount (e.g.
            // 100), not the tax-inclusive finalAmount (118) — AdcNTaxId is the tax used.
            additionalChargeSummary[`Adc${slot}Amt`] = amount;
            additionalChargeSummary[`Adc${slot}TaxId`] = taxId;

            // The item row (saleinvoicedetails) is now shaped exactly like a normal
            // product row (same field set as payloadRows below) instead of a small
            // subset — CGST/SGST/IGST hold the % rate, CGSTAmt/SGSTAmt/IGSTAmt hold
            // the tax amounts, TaxableAmt holds the tax-inclusive final amount (e.g.
            // 100 + 18% tax = 118), and every other normal-row field gets a sensible
            // default/analog for a charge line (no productCode/qty/rate in the usual
            // sense, so ChargeName stands in for productCode/description, qty=1,
            // rate=amount so gross/amount line up the same way a real row's do).
            const chargeItemId = getChargeItemId('SALE', slot);
            additionalChargeItems.push({
                Id: chargeItemId,
                productId: chargeItemId,
                productCode: charge.ChargeName || '',
                description: charge.ChargeName || '',
                UnitId: null,
                unit: '',
                qty: 1,
                rate: amount,
                disc: 0,
                tax: Number(taxPercent.toFixed(2)),
                batchNo: '',
                expDate: null,
                serialNo: '',
                amount: amount,
                taxAmount: Number(taxAmount.toFixed(2)),
                remark: '',
                TaxId: taxId,
                CGST: isSameState ? Number((taxPercent / 2).toFixed(2)) : 0,
                SGST: isSameState ? Number((taxPercent / 2).toFixed(2)) : 0,
                IGST: isSameState ? 0 : Number(taxPercent.toFixed(2)),
                UTGST: '0.00',
                GSTCess: '0.00',
                GSTOth: '0.00',
                GSTEduCess: '0.00',
                GSTEducessAmt: '0.00',
                CGSTAmt: isSameState ? Number((taxAmount / 2).toFixed(2)) : 0,
                SGSTAmt: isSameState ? Number((taxAmount / 2).toFixed(2)) : 0,
                IGSTAmt: isSameState ? 0 : Number(taxAmount.toFixed(2)),
                GSTCEssAmt: '0.00',
                TaxableAmt: Number(finalAmount.toFixed(2)),
                challanDtsID: null,
                challanID: null,
                qoutID: null,
                qoutDtsID: null,
                piId: null,
                piDtsID: null,
                soId: null,
                soDtsID: null,
                PONo: null,
                PODate: null,
                poQty: null,
                type: null,
                size: null,
                color: null,
                freeQty: null,
                per: null,
                pkg: null,
                oth1: null,
                oth2: null,
                oth3: null,
                oth4: null,
                oth5: null,
                oth6: null,
                oth7: null,
                ex4: null,
                ex5: null,
                exQty6: null,
                serialNo: '',
                configData: [],
                _isNew: true,
                configType: null,
                applyBatchNo: 0,
                applySerialNo: 0,
                warrantyMonths: null,
                expiryDays: null,
                srNo: 19999 + slot,
                dispQty: 0,
                gross: amount,
                DiscAmt: 0,
                refNo: null,
                refDate: null,
                refQty: null,
                oth1Amt: null,
                oth2Amt: null,
                oth3Amt: null,
                oth4Amt: null,
                oth5Amt: null,
                oth6Amt: null,
                oth7Amt: null,
                // Fixed identifiers driving the backend's TransType-aware SrNo
                // override (see dispatchController.js / saleInvoiceController.js).
                SrNo: 19999 + slot,
                TransType: 199 + slot,
            });
        }

        const payload = {
            tableData: [...payloadRows, ...additionalChargeItems],
            summary: {
                basic: Number(totals.basic),
                // Display/storage-only pre-Disc/pre-Oth gross total — TaxableAmt
                // storage keeps using `basic` above, unchanged.
                grossBasic: Number(totals.grossBasic),
                discount: Number(totals.discount),
                // Include tax from both normal products and Additional Charges
                cgst: Number(totals.cgst) + Number(chargesSummary.cgst || 0),
                sgst: Number(totals.sgst) + Number(chargesSummary.sgst || 0),
                igst: Number(totals.igst) + Number(chargesSummary.igst || 0),
                // roundOff/total are computed in the totals effect from a finalAmount
                // that already includes chargesSummary, so no further addition here.
                roundOff: Number(totals.roundOff),
                tcsApplied: tcsEnabled ? 1 : 0,
                tcsPercent: tcsEnabled ? Number(tcsPercent) : 0,
                tcsAmount: tcsEnabled ? Number(tcsAmount) : 0,
                total: Number(totals.total),
                ...additionalChargeSummary
            },
            adjustAdvancePayment: adjustAdvancePayment ? 1 : 0,
            adjustAmt: Number(adjustAmt || 0),
            closingBalAmount: Number(closingBalAmount || 0),
            advanceAdjustments: Number(adjustAmt || 0),
            advanceUnchecked: advanceManuallySet.current && !adjustAdvance,
            chargeInputs: chargeInputs
        };

        onNext(payload);
    };

    const formatINR = val => {
        const num = Number(val) || 0;
        return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const columns = [
        { field: 'srNo', headerName: '#', width: 38, align: 'center', headerAlign: 'center' },
        {
            field: 'product', headerName: 'Product', flex: 1, sortable: false, filterable: false,
            renderCell: params => {
                const { productCode, description, unit, tax, batchNo, expDate, serialNo, remark, CGSTAmt, SGSTAmt, IGSTAmt, ChallanNumber, ChallanDate, RefDocLabel } = params.row;
                const isSameState = state?.toLowerCase() === compState?.toLowerCase();
                return (
                    <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
                        <Box>
                            {/* <Typography variant="body2" fontWeight="bold" component="div" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}
                                onClick={e => {
                                    e.stopPropagation();
                                    editRow(params.row.index);
                                }}
                            >
                                {productCode}
                            </Typography> */}

                            <Typography
                                variant="body2"
                                fontWeight="bold"
                                component="div"
                                sx={{
                                    cursor: 'pointer',
                                    color: colors.primary.main,
                                    textDecoration: 'underline',
                                    fontSize: '0.85rem'
                                }}
                                onClick={e => {
                                    e.stopPropagation();
                                    // if (mode !== 'ref' && !creditNoteExists && !isChallanLocked) {
                                    editRow(params.row.index);
                                    // }
                                }}
                            >
                                {productCode}
                            </Typography>
                            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
                                {description}
                            </Typography>
                        </Box>
                        {(isColVisible(COL.UNIT) || isColVisible(COL.TAX_CODE)) && (
                            <Typography variant="caption" display="block">
                                {isColVisible(COL.UNIT) && `Unit: ${unit || 'N/A'}`}
                                {isColVisible(COL.UNIT) && isColVisible(COL.TAX_CODE) && ' | '}
                                {isColVisible(COL.TAX_CODE) && `GST: ${tax}%`}
                            </Typography>
                        )}
                        {(isSameState ? (isColVisible(COL.UTGST) || isColVisible('CGST Rs.')) : isColVisible('IGST Rs.')) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {isSameState
                                    ? [
                                        isColVisible(COL.UTGST) && `SGST: ₹${formatINR(SGSTAmt)}`,
                                        isColVisible('CGST Rs.') && `CGST: ₹${formatINR(CGSTAmt)}`,
                                    ].filter(Boolean).join(' + ')
                                    : `IGST: ₹${formatINR(IGSTAmt)}`}
                            </Typography>
                        )}
                        {((batchNo && isColVisible(COL.BATCH_NO)) || (expDate && isColVisible(COL.EXP_DATE)) || serialNo) && (
                            <Typography variant="caption" display="block">
                                {batchNo && isColVisible(COL.BATCH_NO) && `Batch: ${batchNo}`}
                                {expDate && isColVisible(COL.EXP_DATE) && ` | Exp: ${expDate}`}
                            </Typography>
                        )}
                        {remark && isColVisible(COL.REMARK) && (<Typography variant="caption" display="block" color="text.secondary"> Remark: {remark} </Typography>)}
                        {OTH_FIELDS.some(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)]) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {OTH_FIELDS
                                    .filter(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)])
                                    .map(({ field, col }) => {
                                        const rupees = isOthRupeesMode(col);
                                        const displayVal = params.row[othDisplayField(field, col)];
                                        const amt = params.row[`${field}Amt`];
                                        const sign = Boolean(getColRow(col)?.AddLess) ? '-' : '';
                                        return rupees
                                            ? `${getColLabel(col, field)}: ${sign}₹${formatINR(displayVal)}`
                                            : `${getColLabel(col, field)}: ${displayVal}%${amt ? ` (${sign}₹${formatINR(amt)})` : ''}`;
                                    })
                                    .join(' | ')}
                            </Typography>
                        )}
                        {(ChallanNumber || ChallanDate) && (
                            <Typography variant="caption" display="block" color='blue'>
                                {ChallanNumber && `${RefDocLabel || 'ChallanNo'}: ${ChallanNumber}`}
                                {ChallanDate && ` | Date: ${ChallanDate}`}
                            </Typography>
                        )}
                    </Box>
                );
            }
        },
        { field: 'qty', headerName: 'Qty', width: 50, align: 'center', headerAlign: 'center' },
        { field: 'rate', headerName: 'Rate', width: 100, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
        { field: 'disc', headerName: 'Disc (%)', width: 50, align: 'center', headerAlign: 'center' },
        { field: 'amount', headerName: 'Amount (₹)', width: 100, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.TaxableAmt || 0))}` },
        {
            width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
            renderCell: params => (
                <IconButton
                    size="small"
                    onClick={() => deleteRow(params.row.index)}
                    color="error"
                    disabled={mode === 'ref' || creditNoteExists || isChallanLocked}
                    sx={{ opacity: mode === 'ref' ? 0.4 : 1 }}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            )
        }
    ];


    //persist advance receipt data
    useEffect(() => {

        // user manually unchecked previously
        if (initialData?.advanceUnchecked) {

            setShowAdvanceCheckbox(true);

            setAdjustAdvance(false);

            setSelectedAdvanceRows([]);

            return;
        }

        // restore previously selected advance receipts
        if (
            initialData?.advanceAdjustments &&
            initialData.advanceAdjustments.length > 0
        ) {

            setShowAdvanceCheckbox(true);

            setAdjustAdvance(true);

            setSelectedAdvanceRows(
                initialData.advanceAdjustments.map(item => ({
                    ...item,
                    isManual: true
                }))
            );

            setAdvanceReceipts(prev => {

                // merge existing receipts with selected receipts
                const existingIds = prev.map(p => p.ReceiptId);

                const missing = initialData.advanceAdjustments.filter(
                    x => !existingIds.includes(x.ReceiptId)
                );

                return [...prev, ...missing];
            });
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setState calls) on every parent re-render, not just when the
        // actual saved values change.
    }, [initialData?.advanceUnchecked, initialData?.advanceAdjustments]);

    // Fetch online stock details when current product changes
    useEffect(() => {
        const fetchOnlineStock = async () => {
            if (isShowOnlineStockEnabled && current.Id) {
                console.log('📊 Invoice_Steeper: Fetching online stock details for product:', current.Id);
                const details = await getOnlineStockDetails(current.Id);
                console.log('📊 Invoice_Steeper: Online stock details:', details);
                setOnlineStockDetails({
                    closingStock: details.closingStock,
                    maxLevel: details.maxLevel,
                    minLevel: details.minLevel,
                });
            }
        };
        fetchOnlineStock();
    }, [current.Id, isShowOnlineStockEnabled, getOnlineStockDetails]);

    return (
        <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
                <Box display="flex" flexDirection="column" gap={2} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 2, borderRight: isSmall ? 'none' : `1px solid ${themeColors.neutral.line}`, flex: { lg: '1 1 100%' }, }} >
                    <Box>
                        <DropdownProductCode
                            ref={productCodeRef}
                            id="productCode"
                            options={allProducts}
                            value={current.productCode}
                            onSelect={handleSelect}
                            onNewProductAdded={loadAllProducts}
                            onProductMasterClose={handleProductAdded}
                            connectionString={connectionString}
                            searchBy="code"
                            disabled={mode === 'ref' && editIndex !== null}
                            autoFocus={!initialData?.tableData?.length}
                        />
                        {!!errors.productCode && (<Typography color="error" variant="caption"> {errors.productCode} </Typography>)}
                    </Box>
                    {/* <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} /> */}
                    {isColVisible(COL.DESCRIPTION) && (
                        <DropdownProductCode
                            id="description"
                            label="Description"
                            options={allProducts}
                            value={current.description}
                            onSelect={handleSelect}
                            onNewProductAdded={loadAllProducts}
                            connectionString={connectionString}
                            searchBy="description"
                            disabled={mode === 'ref' && editIndex !== null}
                            onProductMasterClose={handleProductAdded}
                        />
                    )}
                    {(isColVisible(COL.PO_NO) || isColVisible(COL.PO_DATE) || isColVisible(COL.PO_QTY)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PO_NO) && (
                                <TextField label={getColLabel(COL.PO_NO, 'PO No')} size="small" fullWidth value={current.PONo} onChange={handleChange('PONo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_DATE) && (
                                <TextField label={getColLabel(COL.PO_DATE, 'PO Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.PODate} onChange={handleChange('PODate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_QTY) && (
                                <TextField label={getColLabel(COL.PO_QTY, 'PO Qty')} type="number" size="small" fullWidth value={current.poQty} onChange={handleChange('poQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.TYPE) || isColVisible(COL.SIZE) || isColVisible(COL.COLOR)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.TYPE) && (
                                <TextField label={getColLabel(COL.TYPE, 'Type')} size="small" fullWidth value={current.type} onChange={handleChange('type')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.SIZE) && (
                                <TextField label={getColLabel(COL.SIZE, 'Size')} size="small" fullWidth value={current.size} onChange={handleChange('size')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.COLOR) && (
                                <TextField label={getColLabel(COL.COLOR, 'Color')} size="small" fullWidth value={current.color} onChange={handleChange('color')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    <Box display="flex" flexDirection="row" gap={1.5}>
                        {isColVisible(COL.UNIT) && (
                            <TextField
                                label="Unit"
                                required
                                select
                                fullWidth
                                size='small'
                                value={String(current.UnitId)}
                                onChange={handleChange('UnitId')}
                                disabled={mode === 'ref' && editIndex !== null}
                                SelectProps={{ native: true }}
                                InputLabelProps={{ sx: requiredAsteriskStyle }}
                                sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                            >
                                <option value=""></option>
                                {unitOptions.map(u => (
                                    <option key={u.UnitId} value={u.UnitId}>
                                        {u.unit}
                                    </option>
                                ))}
                            </TextField>
                        )}
                        {/* <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} /> */}
                        {isColVisible(COL.TAX_CODE) && (
                            <Dropdown
                                id="gst"
                                label="GST"
                                valueKey="Id"
                                labelKey="value"
                                value={current.TaxId != null ? String(current.TaxId) : ""}
                                options={gsts}
                                required
                                disabled={mode === 'ref' && editIndex !== null}
                                onChange={(opt) => {
                                    if (!opt) {
                                        setCurrent(prev => ({ ...prev, tax: 0, TaxId: null }));
                                    } else {
                                        const gstValue = getTaxPercent(opt.value);
                                        setCurrent(prev => ({
                                            ...prev,
                                            tax: gstValue,
                                            TaxId: opt.Id
                                        }));
                                    }
                                }}
                                error={!!errors.TaxId}
                            />
                        )}
                    </Box>
                    {(isColVisible(COL.BATCH_NO) || isColVisible(COL.EXP_DATE)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.BATCH_NO) && (
                                <TextField label={getColLabel(COL.BATCH_NO, 'Batch No')} size="small" fullWidth value={current.batchNo} onChange={handleChange('batchNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.EXP_DATE) && (
                                <TextField label={getColLabel(COL.EXP_DATE, 'Exp. Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.expDate} onChange={handleChange('expDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    <Box display="flex" flexDirection="row" gap={1.5}>
                        {/* Conditional layout: single row if MRP enabled, separate rows otherwise */}
                        {isApplyMRPInSaleEnabled ? (
                            // When Apply MRP in Sale is enabled: Qty, MRP, Rate, Disc in single row
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                {isColVisible(COL.QTY) && (
                                    <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                        <TextField
                                            label="Qty"
                                            required
                                            size='small'
                                            fullWidth
                                            type="number"
                                            inputProps={{ min: 0, step: 'any' }}
                                            value={current.qty}
                                            onChange={handleChange('qty')}
                                            disabled={mode === 'ref' && editIndex !== null}
                                            error={!!errors.qty}
                                            helperText={errors.qty}
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                        />
                                    </Box>
                                )}
                                {/* MRP Field - visible when Apply MRP is enabled */}
                                <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                    <TextField
                                        label="MRP"
                                        size='small'
                                        fullWidth
                                        type="number"
                                        inputProps={{ min: 0 }}
                                        value={current.MRP}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            const mrpValue = Number(val) || 0;

                                            setCurrent(prev => ({
                                                ...prev,
                                                MRP: val === '' ? '' : mrpValue
                                            }));

                                            if (mrpValue > 0 && current.tax > 0) {
                                                const newRate = calculateSaleRateFromMRP(mrpValue, current.tax);
                                                const taxableAmt = current.qty * newRate * (1 - current.disc / 100);
                                                const taxAmount = taxableAmt * (current.tax / 100);

                                                setCurrent(prev => ({
                                                    ...prev,
                                                    rate: newRate,
                                                    amount: taxableAmt.toFixed(2),
                                                    taxAmount: taxAmount.toFixed(2),
                                                    CGST: state?.toLowerCase() === compState?.toLowerCase() ? (current.tax / 2).toFixed(2) : '0.00',
                                                    SGST: state?.toLowerCase() === compState?.toLowerCase() ? (current.tax / 2).toFixed(2) : '0.00',
                                                    IGST: state?.toLowerCase() !== compState?.toLowerCase() ? current.tax.toFixed(2) : '0.00',
                                                    CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
                                                    SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
                                                    IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
                                                    TaxableAmt: taxableAmt.toFixed(2)
                                                }));
                                            }
                                        }}
                                        InputLabelProps={{ sx: requiredAsteriskStyle }}
                                        sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                    />
                                </Box>
                                {isColVisible(COL.RATE) && (
                                    <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                        <TextField
                                            label="Rate"
                                            required
                                            size='small'
                                            fullWidth
                                            type="number"
                                            inputProps={{ min: 0 }}
                                            value={current.rate}
                                            onChange={handleChange('rate')}
                                            disabled={true}
                                            error={mode === 'ref' && current.productCode && Number(current.rate) <= 0}
                                            helperText={mode === 'ref' && current.productCode && Number(current.rate) <= 0 ? 'Rate must be greater than 0' : ''}
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                        />
                                    </Box>
                                )}
                                {isColVisible(COL.DISC) && (
                                    <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                        <TextField
                                            label={getColLabel(COL.DISC, 'Disc%')}
                                            size="small"
                                            fullWidth
                                            type="number"
                                            inputProps={{ min: 0, max: 100 }}
                                            value={current.disc}
                                            error={!!discError}
                                            helperText={discError}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === "") {
                                                    setDiscError("");
                                                    handleBaseFieldChange('disc')(e);
                                                    return;
                                                }
                                                if (Number(value) > 100) {
                                                    setDiscError("can't be > 100%");
                                                    return;
                                                }
                                                setDiscError("");
                                                handleBaseFieldChange('disc')(e);
                                            }}
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    height: 38,
                                                    alignItems: 'center'
                                                }
                                            }}
                                        />
                                    </Box>
                                )}
                            </Box>
                        ) : (
                            // When Apply MRP is not enabled: Qty, Rate, Disc in separate columns (original layout)
                            <>
                                {isColVisible(COL.QTY) && (
                                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                        <TextField
                                            label="Qty"
                                            required
                                            size='small'
                                            fullWidth
                                            type="number"
                                            inputProps={{ min: 0, step: 'any' }}
                                            value={current.qty}
                                            onChange={handleChange('qty')}
                                            disabled={mode === 'ref' && editIndex !== null}
                                            error={!!errors.qty}
                                            helperText={errors.qty}
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                        />
                                    </Box>
                                )}
                                {isColVisible(COL.RATE) && (
                                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                        <TextField
                                            label="Rate"
                                            required
                                            size='small'
                                            fullWidth
                                            type="number"
                                            inputProps={{ min: 0 }}
                                            value={current.rate}
                                            onChange={handleChange('rate')}
                                            error={mode === 'ref' && current.productCode && Number(current.rate) <= 0}
                                            helperText={mode === 'ref' && current.productCode && Number(current.rate) <= 0 ? 'Rate must be greater than 0' : ''}
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                        />
                                        {current.MRP && Number(current.MRP) > 0 && (
                                            <Typography variant="body2" sx={{ color: colors.primary.main, fontSize: '12px', ml: 1, mt: -0.5, fontWeight: 500 }}>
                                               MRP: ₹{Number(current.MRP).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </Typography>
                                        )}
                                    </Box>
                                )}
                                {isColVisible(COL.DISC) && (
                                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                        <TextField
                                            label={getColLabel(COL.DISC, 'Disc%')}
                                            size="small"
                                            fullWidth
                                            type="number"
                                            inputProps={{ min: 0, max: 100 }}
                                            value={current.disc}
                                            error={!!discError}
                                            helperText={discError}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === "") {
                                                    setDiscError("");
                                                    handleBaseFieldChange('disc')(e);
                                                    return;
                                                }
                                                if (Number(value) > 100) {
                                                    setDiscError("can't be > 100%");
                                                    return;
                                                }
                                                setDiscError("");
                                                handleBaseFieldChange('disc')(e);
                                            }}
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    height: 38,
                                                    alignItems: 'center'
                                                }
                                            }}
                                        />
                                    </Box>
                                )}
                            </>
                        )}
                        {/* {isTrackingEnabled && (
                            <IconButton
                                disabled={
                                    trackingConfig.applyBatchNo !== 1 &&
                                    trackingConfig.applySerialNo !== 1
                                }

                                // onClick={async () => {
                                //     let type = null;

                                //     if (trackingConfig.applySerialNo === 1) {
                                //         type = "serial";
                                //     } else if (trackingConfig.applyBatchNo === 1) {
                                //         type = "batch";
                                //     } else {
                                //         return;
                                //     }

                                //     setTrackingType(type);

                                //     const payload = {
                                //         itemId: current.Id,
                                //         CompId: companyId,
                                //         trackingType: type,
                                //         saleInvoiceId: saleInvoiceId || 0,
                                //         saleInvoiceDtsId: current.SaleInvoiceDtsId || 0
                                //     };

                                //     const res = await fetchStock(payload);

                                //     let stock = [];

                                //     if (res?.success && res.data?.length > 0) {

                                //         stock = res.data.map(item => {

                                //             // ðŸ” find existing (user selected)
                                //             const existing = (current.configData || []).find(d => {
                                //                 if (type === "serial") {
                                //                     return Number(d.id) === Number(item.id)
                                //                 }
                                //                 if (type === "batch") {
                                //                     return Number(d.id) === Number(item.id);
                                //                 }
                                //                 return false;
                                //             });

                                //             // ================= SERIAL =================
                                //             if (type === "serial") {

                                //                 const existing = (current.configData || []).find(
                                //                     d =>
                                //                         Number(d.id) === Number(item.id) &&
                                //                         (Number(d.selected_qty) > 0 || Number(d.is_selected) === 1)
                                //                 );

                                //                 const isSelected =
                                //                     existing
                                //                         ? 1
                                //                         : Number(item.is_selected || 0);

                                //                 return {
                                //                     ...item,
                                //                     value: item.SerialNo || item.value,

                                //                     is_selected: isSelected,
                                //                     selected_qty: isSelected ? 1 : 0,

                                //                     qty: Number(item.available_qty ?? 1),
                                //                     available_qty: Number(item.available_qty ?? 0)
                                //                 };
                                //             }

                                //             // ================= BATCH =================
                                //             if (type === "batch") {

                                //                 const selectedQty =
                                //                     existing
                                //                         ? Number(existing.selected_qty || 0)
                                //                         : Number(item.selected_qty || 0); // backend respected

                                //                 return {
                                //                     ...item,
                                //                     value: item.BatchNo || item.value,

                                //                     is_selected: selectedQty > 0 ? 1 : 0,
                                //                     selected_qty: selectedQty,

                                //                     // â— always use display/available qty
                                //                     qty: Number(item.display_qty ?? item.available_qty ?? 0),
                                //                     available_qty: Number(item.available_qty ?? 0),
                                //                     display_qty: item.display_qty != null
                                //                         ? Number(item.display_qty)
                                //                         : undefined
                                //                 };
                                //             }

                                //             return item;
                                //         });
                                //     }


                                //     const selected = stock.filter(item => {
                                //         if (type === "serial") return item.is_selected === 1;
                                //         if (type === "batch") return Number(item.selected_qty) > 0;
                                //         return false;
                                //     });

                                //     setModalStockDetails({
                                //         stock: stock,
                                //         selected: selected
                                //     });

                                //     setSerBatchModalOpen(true);
                                // }}

                                onClick={async () => {
                                    let type = null;
                                    if (trackingConfig.applySerialNo === 1) type = "serial";
                                    else if (trackingConfig.applyBatchNo === 1) type = "batch";
                                    else return;

                                    setTrackingType(type);

                                    const payload = {
                                        itemId: current.Id,
                                        CompId: companyId,
                                        trackingType: type,
                                        saleInvoiceId: saleInvoiceId || 0,
                                        saleInvoiceDtsId: current.saleInvoiceDtsId || 0
                                    };

                                    const res = await fetchStock(payload);
                                    if (!res?.success) return;

                                    const isNewProduct = editIndex === null;   // â† KEY CHECK

                                    const stock = (res.data || []).map(item => {

                                        // For new product â€” always unselected
                                        if (isNewProduct) {
                                            return {
                                                ...item,
                                                value: item.SerialNo || item.BatchNo || item.value,
                                                is_selected: 0,
                                                selected_qty: 0,
                                                qty: type === "serial"
                                                    ? 1
                                                    : Number(item.display_qty ?? item.available_qty ?? 0),
                                                available_qty: Number(item.available_qty ?? 0),
                                                display_qty: item.display_qty != null ? Number(item.display_qty) : undefined
                                            };
                                        }

                                        // For existing product â€” restore ONLY user's previous selection
                                        const existing = (current.configData || []).find(
                                            d => Number(d.id) === Number(item.id)
                                        );
                                        if (type === "serial") {
                                            // âœ… existing found â†’ use it, not found â†’ 0 (NOT backend's is_selected)
                                            const isSelected = existing ? Number(existing.is_selected ?? 0) : 0;
                                            return {
                                                ...item,
                                                value: item.SerialNo || item.value,
                                                is_selected: isSelected,
                                                selected_qty: isSelected ? 1 : 0,
                                                qty: 1,
                                                available_qty: Number(item.available_qty ?? 0)
                                            };
                                        }

                                        if (type === "batch") {
                                            // âœ… existing found â†’ use it, not found â†’ 0 (NOT backend's selected_qty)
                                            const selectedQty = existing ? Number(existing.selected_qty ?? 0) : 0;
                                            return {
                                                ...item,
                                                value: item.BatchNo || item.value,
                                                is_selected: selectedQty > 0 ? 1 : 0,
                                                selected_qty: selectedQty,
                                                qty: Number(item.display_qty ?? item.available_qty ?? 0),
                                                available_qty: Number(item.available_qty ?? 0),
                                                display_qty: item.display_qty != null ? Number(item.display_qty) : undefined
                                            };
                                        }

                                        return item;
                                    });

                                    const selected = stock.filter(item => {
                                        if (type === "serial") return Number(item.is_selected) === 1;
                                        if (type === "batch") return Number(item.selected_qty) > 0;
                                        return false;
                                    });

                                    setSerBatchModalOpen(false);
                                    setTimeout(() => {
                                        setModalStockDetails({ stock, selected });
                                        setModalOpenTrigger(prev => prev + 1);
                                        setSerBatchModalOpen(true);
                                    }, 0);
                                }}
                                sx={{
                                    border: '1px solid lightgray',
                                    borderRadius: 1,
                                    height: 38,
                                    width: 37,
                                    opacity:
                                        trackingConfig.applyBatchNo !== 1 &&
                                            trackingConfig.applySerialNo !== 1
                                            ? 0.4
                                            : 1
                                }}
                            >
                                <FaCartShopping />
                            </IconButton>
                        )} */}
                    </Box>
                    {(isColVisible(COL.PKG) || isColVisible(COL.FREE_QTY) || isColVisible(COL.PER)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PKG) && (
                                <TextField label={getColLabel(COL.PKG, 'Pkg')} size="small" fullWidth value={current.pkg || ''} onChange={handleChange('pkg')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.FREE_QTY) && (
                                <TextField label={getColLabel(COL.FREE_QTY, 'Free Qty')} type="number" size="small" fullWidth value={current.freeQty} onChange={handleChange('freeQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PER) && (
                                <TextField label={getColLabel(COL.PER, 'Per')} size="small" fullWidth value={current.per} onChange={handleChange('per')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH1) || isColVisible(COL.OTH2) || isColVisible(COL.OTH3)) && (
                        <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1.5}>
                            {isColVisible(COL.OTH1) && (
                                <TextField label={getColLabel(COL.OTH1, 'Oth 1')} size="small" fullWidth type="number" value={current[othDisplayField('oth1', COL.OTH1)] || ''} onChange={handleOthChange('oth1', COL.OTH1)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && (
                                <TextField label={`${getColLabel(COL.OTH1, 'Oth 1')} Amount`} size="small" fullWidth disabled value={current.oth1Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && (
                                <TextField label={getColLabel(COL.OTH2, 'Oth 2')} size="small" fullWidth type="number" value={current[othDisplayField('oth2', COL.OTH2)] || ''} onChange={handleOthChange('oth2', COL.OTH2)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && (
                                <TextField label={`${getColLabel(COL.OTH2, 'Oth 2')} Amount`} size="small" fullWidth disabled value={current.oth2Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && (
                                <TextField label={getColLabel(COL.OTH3, 'Oth 3')} size="small" fullWidth type="number" value={current[othDisplayField('oth3', COL.OTH3)] || ''} onChange={handleOthChange('oth3', COL.OTH3)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && !isOthRupeesMode(COL.OTH3) && (
                                <TextField label={`${getColLabel(COL.OTH3, 'Oth 3')} Amount`} size="small" fullWidth disabled value={current.oth3Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.UTGST) || isColVisible(COL.GST_CESS) || isColVisible(COL.GST_OTH)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.UTGST) && (
                                <TextField label={getColLabel(COL.UTGST, 'UTGST')} size="small" fullWidth type="number" value={current.UTGST} onChange={handleChange('UTGST')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_CESS) && (
                                <TextField label={getColLabel(COL.GST_CESS, 'GST Cess')} size="small" fullWidth type="number" value={current.GSTCess} onChange={handleChange('GSTCess')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_OTH) && (
                                <TextField label={getColLabel(COL.GST_OTH, 'GST Oth')} size="small" fullWidth type="number" value={current.GSTOth} onChange={handleChange('GSTOth')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.EX4) || isColVisible(COL.EX5) || isColVisible(COL.EX_QTY6)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.EX4) && <TextField size="small" label={getColLabel(COL.EX4, 'EX4')} value={current.ex4 || ''} onChange={(e) => setCurrent(p => ({ ...p, ex4: e.target.value }))} />}
                            {isColVisible(COL.EX5) && <TextField size="small" label={getColLabel(COL.EX5, 'EX5')} value={current.ex5 || ''} onChange={(e) => setCurrent(p => ({ ...p, ex5: e.target.value }))} />}
                            {isColVisible(COL.EX_QTY6) && <TextField size="small" label={getColLabel(COL.EX_QTY6, 'EXQty6')} type="number" value={current.exQty6 || ''} onChange={(e) => setCurrent(p => ({ ...p, exQty6: e.target.value }))} />}
                        </Box>
                    )}
                    {isColVisible(COL.SERIAL_NO) && <TextField size="small" label={getColLabel(COL.SERIAL_NO, 'Serial No')} value={current.serialNo || ''} onChange={(e) => setCurrent(p => ({ ...p, serialNo: e.target.value }))} fullWidth />}
                    {(isColVisible(COL.OTH4) || isColVisible(COL.OTH5)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH4) && <TextField size="small" type="number" label={getColLabel(COL.OTH4, 'Oth 4')} value={current[othDisplayField('oth4', COL.OTH4)] || ''} onChange={handleOthChange('oth4', COL.OTH4)} />}
                            {isColVisible(COL.OTH4) && !isOthRupeesMode(COL.OTH4) && <TextField size="small" disabled label={`${getColLabel(COL.OTH4, 'Oth 4')} Amount`} value={current.oth4Amt || ''} />}
                            {isColVisible(COL.OTH5) && <TextField size="small" type="number" label={getColLabel(COL.OTH5, 'Oth 5')} value={current[othDisplayField('oth5', COL.OTH5)] || ''} onChange={handleOthChange('oth5', COL.OTH5)} />}
                            {isColVisible(COL.OTH5) && !isOthRupeesMode(COL.OTH5) && <TextField size="small" disabled label={`${getColLabel(COL.OTH5, 'Oth 5')} Amount`} value={current.oth5Amt || ''} />}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH6) || isColVisible(COL.OTH7)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH6) && <TextField size="small" type="number" label={getColLabel(COL.OTH6, 'Oth 6')} value={current[othDisplayField('oth6', COL.OTH6)] || ''} onChange={handleOthChange('oth6', COL.OTH6)} />}
                            {isColVisible(COL.OTH6) && !isOthRupeesMode(COL.OTH6) && <TextField size="small" disabled label={`${getColLabel(COL.OTH6, 'Oth 6')} Amount`} value={current.oth6Amt || ''} />}
                            {isColVisible(COL.OTH7) && <TextField size="small" type="number" label={getColLabel(COL.OTH7, 'Oth 7')} value={current[othDisplayField('oth7', COL.OTH7)] || ''} onChange={handleOthChange('oth7', COL.OTH7)} />}
                            {isColVisible(COL.OTH7) && !isOthRupeesMode(COL.OTH7) && <TextField size="small" disabled label={`${getColLabel(COL.OTH7, 'Oth 7')} Amount`} value={current.oth7Amt || ''} />}
                        </Box>
                    )}
                    {isColVisible(COL.AMOUNT) && (
                        <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                    )}
                    {isColVisible(COL.REMARK) && (
                        <Box>
                            <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} inputProps={{ maxLength: 250 }} helperText={`${(current.remark || '').length}/250 characters`} />
                        </Box>
                    )}
                    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                        {isShowOnlineStockEnabled && current.Id && (
                            <Box display="flex" gap={2} justifyContent="center">
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: themeColors.neutral.sub }}>
                                        Closing Stock
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: onlineStockDetails.closingStock <= 0 ? themeColors.error.dark : themeColors.success.dark,
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.closingStock !== null ? onlineStockDetails.closingStock.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: themeColors.neutral.sub }}>
                                        Max Level
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: colors.primary.main,
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.maxLevel !== null ? onlineStockDetails.maxLevel.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: themeColors.neutral.sub }}>
                                        Min Level
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#f57c00',
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.minLevel !== null ? onlineStockDetails.minLevel.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        <Button
                            variant="outlined"
                            onClick={addProduct}
                            sx={{ minWidth: 180 }}
                            disabled={mode === 'ref' && editIndex === null ? true : (creditNoteExists || (isChallanLocked && mode !== 'ref'))}
                        >
                            {editIndex != null ? 'Update Product' : 'Add Product'}
                        </Button>
                    </Box>
                </Box>
                <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
                    {isMobile ? (
                        <Box>
                            {rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((row, i) => (
                                <Box
                                    key={i}
                                    sx={{
                                        border: `1px solid ${themeColors.neutral.lineStrong}`,
                                        borderRadius: 2,
                                        p: 1.5,
                                        mb: 1.5,
                                        cursor: isChallanLocked ? 'not-allowed' : 'pointer',   // âœ… Added
                                        color: isChallanLocked && "text.disabled",
                                    }}
                                >
                                    {/* <Typography sx={{ fontWeight: 600 }}>
                                        {row.productCode} â€” <span style={{ fontStyle: "italic", fontWeight: "normal" }}>
                                            {row.description}
                                        </span>
                                    </Typography> */}
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            flexWrap: "wrap"
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                minWidth: 24,
                                                height: 24,
                                                borderRadius: "6px",
                                                backgroundColor: "#eef2ff",
                                                color: "#4338ca",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "12px",
                                                fontWeight: 700
                                            }}
                                        >
                                            {row.srNo}
                                        </Box>

                                        <Box component="span">
                                            {row.productCode}
                                        </Box>

                                        <Box
                                            component="span"
                                            sx={{
                                                fontStyle: "italic",
                                                fontWeight: 400,
                                                color: "#475569"
                                            }}
                                        >
                                            â€” {row.description}
                                        </Box>
                                    </Typography>

                                    {(row.ChallanNumber || row.ChallanDate) && (
                                        <Typography variant="caption" display="block" color='blue'>
                                            {row.ChallanNumber && `${row.RefDocLabel || 'ChallanNo'}: ${row.ChallanNumber}`}
                                            {row.ChallanDate && ` | Date: ${row.ChallanDate}`}
                                        </Typography>
                                    )}

                                    <Grid container justifyContent="space-between">
                                        <Typography>Qty:</Typography>
                                        <Typography>{row.qty}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Rate:</Typography>
                                        <Typography>₹{row.rate}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Disc:</Typography>
                                        <Typography>{row.disc}%</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Amount:</Typography>
                                        <Typography>₹{row.amount}</Typography>
                                    </Grid>

                                    {/* DELETE / EDIT BUTTONS IF NEEDED */}
                                    <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
                                        <IconButton size="small" onClick={() => editRow(i)} disabled={isChallanLocked && mode !== 'ref'}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={mode === 'ref' || isChallanLocked}>
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        <DataGrid
                            rows={rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((r, i) => ({ ...r, id: i + 1, index: i }))}
                            columns={columns}
                            getRowHeight={() => 'auto'}
                            autoHeight
                            disableRowSelectionOnClick
                            hideFooter
                            sx={{
                                mt: 5,
                                border: `1px solid ${themeColors.neutral.lineStrong}`,
                                borderRadius: 1,
                                '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
                                '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface }
                            }}
                        />
                    )}
                    <Box mt={3}>
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Basic Amount</Typography>
                            <Typography>₹{formatINR(totals.basic)}</Typography>
                        </Grid>
                        <Typography variant="caption" color="text.secondary" display="block" mb={1}>
                            Total Discounted Amount: ₹{formatINR(totals.discount)}
                        </Typography>

                        {additionalCharges.length > 0 && (
                            <Box mb={2}>
                                <Accordion
                                    expanded={chargesCollapsibleOpen !== false ? true : chargesCollapsibleOpen}
                                    onChange={() => setChargesCollapsibleOpen(!chargesCollapsibleOpen)}
                                    sx={{ width: '100%' }}
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ py: 0.75, minHeight: 'auto' }}>
                                        <Typography variant="subtitle2">Charges</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ py: 1, px: 1 }}>
                                        <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <colgroup>
                                                    <col style={{ width: '45%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '19%' }} />
                                                </colgroup>
                                                <thead>
                                                    <tr style={{ backgroundColor: themeColors.neutral.surfaceMuted, borderBottom: `2px solid ${themeColors.neutral.line}` }}>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Charge Name</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Amount</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Tax</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Final Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {additionalCharges.map(charge => {
                                                        const key = charge.TransType;
                                                        if (!chargeInputs[key]) {
                                                            updateChargeInput(key, { amount: '', taxId: charge.TaxId ?? null });
                                                        }
                                                        const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
                                                        const { finalAmount } = getChargeFinalAmounts(charge, input);

                                                        return (
                                                            <tr key={key} style={{ borderBottom: `1px solid ${themeColors.neutral.line}` }}>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    <Typography variant="caption" sx={{ fontSize: '12px' }}>{charge.ChargeName}</Typography>
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={input.amount}
                                                                        onChange={(e) => updateChargeInput(key, { amount: e.target.value })}
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    {charge.TaxEnabled ? (
                                                                        <Dropdown
                                                                            id={`charge-tax-${key}`}
                                                                            valueKey="Id"
                                                                            labelKey="value"
                                                                            value={input.taxId ? String(input.taxId) : ""}
                                                                            options={gsts}
                                                                            onChange={(opt) => updateChargeInput(key, { taxId: opt ? opt.Id : null })}
                                                                        />
                                                                    ) : (
                                                                        <Typography variant="caption" sx={{ color: themeColors.neutral.muted, fontSize: '12px' }}>N/A</Typography>
                                                                    )}
                                                                </td>
                                                                <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={finalAmount.toFixed(2)}
                                                                        disabled
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, backgroundColor: themeColors.neutral.surfaceMuted, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        )}

                        {state?.toLowerCase() === compState?.toLowerCase() ? (
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>CGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.cgst) + chargesSummary.cgst)}</Typography>
                                </Grid>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>SGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.sgst) + chargesSummary.sgst)}</Typography>
                                </Grid>
                            </>
                        ) : (
                            totals.igst > 0 && (
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>IGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.igst) + chargesSummary.igst)}</Typography>
                                </Grid>
                            )
                        )}
                        {/* TCS ROW */}
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>

                            {/* LEFT SIDE */}
                            <Grid item display="flex" alignItems="center" gap={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={tcsEnabled}
                                            onChange={(e) => setTcsEnabled(e.target.checked)}
                                            disabled={tcsDisabled}
                                        />
                                    }
                                    label="TCS"
                                />

                                {tcsEnabled && (
                                    <>
                                        <TextField
                                            label="TCS %"
                                            size="small"
                                            type="number"
                                            value={tcsPercent}
                                            onChange={(e) => {
                                                let val = e.target.value;

                                                // Allow empty (for backspace)
                                                if (val === '') {
                                                    setTcsPercent('');
                                                    return;
                                                }

                                                // Regex: numbers with max 5 decimal places
                                                const regex = /^\d*\.?\d{0,5}$/;

                                                if (!regex.test(val)) {
                                                    return; // âŒ ignore invalid input
                                                }

                                                let num = Number(val);

                                                if (num < 0) num = 0;
                                                if (num > 100) num = 100;

                                                setTcsPercent(val); // keep as string for precision
                                            }}
                                            inputProps={{ min: 0, max: 100 }}
                                            sx={{ width: 90 }}
                                        />

                                        <TextField
                                            label="Amt"
                                            size="small"
                                            value={formatINR(tcsAmount)}
                                            disabled
                                            sx={{ width: 120 }}
                                        />
                                    </>
                                )}
                            </Grid>

                            {/* RIGHT SIDE (LIKE OTHER ROWS) */}
                            <Grid item>
                                <Typography>
                                    ₹{formatINR(tcsAmount)}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
                            <Typography>₹{formatINR(totals.roundOff)}</Typography>
                        </Grid>

                        <Divider sx={{ my: 1 }} />
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Typography fontWeight={600}>Total Amount</Typography>
                            <Typography fontWeight={600}>₹{formatINR(Number(totals.total))}</Typography>
                            {/* <Typography fontWeight={600}>₹{formatINR(finalTotal)}</Typography> */}
                        </Grid>
                    </Box>
                </Box>
            </Box>
            {!!errors.global && (
                <Typography color="error" sx={{ mt: 2 }}>
                    {errors.global}
                </Typography>
            )}


            <FormControlLabel
                control={
                    <Checkbox
                        checked={adjustAdvancePayment}
                        onChange={handleAdvancePaymentChange}
                        disabled={advancePaymentLoading}
                    />
                }
                label="Advance Payment"
            />

            {adjustAdvancePayment && (
                <Box mb={2} mt={1}>
                    {advancePaymentLoading ? (
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                color: 'gray'
                            }}
                        >
                            Loading...
                        </Typography>
                    ) : advancePaymentMessage.includes('no Advance') ? (
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                color: 'error.main'
                            }}
                        >
                            {advancePaymentMessage}
                        </Typography>
                    ) : advancePaymentMessage || mode === 'edit' ? (
                        <>
                            {advancePaymentMessage && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 600,
                                        color: 'green',
                                        mb: 1
                                    }}
                                >
                                    {advancePaymentMessage}
                                </Typography>
                            )}
                            <TextField
                                label="Adjust Amount"
                                type="number"
                                size="small"
                                value={adjustAmt}
                                onChange={(e) => {
                                    let val = parseFloat(e.target.value) || 0;

                                    // Validate: Adjust Amount should be <= Closing Balance
                                    if (val > closingBalAmount) {
                                        setAdjustAmtError(`Amount cannot exceed ₹${formatINR(closingBalAmount)}`);
                                        return;
                                    }

                                    if (val < 0) {
                                        setAdjustAmtError('Amount cannot be negative');
                                        return;
                                    }

                                    setAdjustAmt(val);
                                    setAdjustAmtError('');
                                }}
                                inputProps={{ step: "0.01", min: "0" }}
                                error={!!adjustAmtError}
                                helperText={adjustAmtError}
                                fullWidth
                                sx={{ mt: 1 }}
                            />
                        </>
                    ) : null}
                </Box>
            )}

            <Box mt={1} display="flex" justifyContent="flex-end">
                <Button
                    variant="contained"
                    onClick={handleNext}
                    disabled={isEditingMode}
                >
                    Next
                </Button>

            </Box>


            {/* <SerialBatchModal
                open={serBatchModalOpen}
                onClose={() => setSerBatchModalOpen(false)}
                type={trackingType}
                warrantyMonths={trackingConfig.warrantyMonths}
                expiryDays={trackingConfig.expiryDays}
                initialData={modalStockDetails}
                existingBatchSelections={getExistingBatchSelections(current.Id)}

                onSave={(res) => {
                    if (res.configType === "serial") {
                        setCurrent(prev => ({
                            ...prev,
                            configData: (res.data || []).map(item => ({
                                ...item,
                                id: Number(item.id),
                                value: item.value,
                                is_selected: 1,        // â† FORCE THIS
                                selected_qty: 1,       // â† FORCE THIS
                                available_qty: Number(item.available_qty ?? 0),
                                qty: 1
                            })),
                            configType: "serial",
                            warrantyMonths: trackingConfig.warrantyMonths,
                        }));
                    } else {
                        setCurrent(prev => ({
                            ...prev,
                            configData: (res.data || []).map(item => ({
                                ...item,
                                id: Number(item.id),
                                value: item.value || item.BatchNo || "",
                                is_selected: Number(item.qty) > 0 ? 1 : 0,   // â† FORCE THIS
                                selected_qty: Number(item.qty || 0),           // â† FORCE THIS
                                available_qty: Number(item.available_qty ?? 0),
                                display_qty: item.display_qty != null ? Number(item.display_qty) : undefined,
                                qty: Number(item.qty ?? 0)
                            })),
                            configType: "batch",
                            expiryDays: trackingConfig.expiryDays,
                        }));
                    }
                }}
                totalProductQty={current.qty}
                key={modalOpenTrigger}
                // existingSerials={existingSerials}

                invoiceDate={invoiceDate}
                moduleName={"Sale Invoice"}

                productCode={current.productCode}
                rowSrNo={current.srNo}
            /> */}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={8000}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    severity={snackbar.severity}
                    variant="filled"
                    onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                    sx={{ width: '100%', maxWidth: 500 }}
                >
                    {snackbar.details?.length > 0 ? (
                        <Box>
                            <Typography fontSize={14} fontWeight={600}>
                                Stock quantity exceeded for {snackbar.details.length} product{snackbar.details.length > 1 ? 's' : ''}.
                            </Typography>
                            <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                                {snackbar.details[0].summary}
                                {snackbar.details.length > 1 && ` and ${snackbar.details.length - 1} more...`}
                            </Typography>
                            <Typography
                                fontSize={12}
                                sx={{
                                    mt: 0.5,
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                    fontWeight: 600
                                }}
                                onClick={() => {
                                    setSnackbar(prev => ({ ...prev, open: false }));
                                    setErrorDialog({ open: true, details: snackbar.details });
                                }}
                            >
                                See full details â†’
                            </Typography>
                        </Box>
                    ) : (
                        <Typography fontSize={13}>{snackbar.message}</Typography>
                    )}
                </Alert>
            </Snackbar>

            <Dialog
                open={errorDialog.open}
                onClose={() => setErrorDialog({ open: false, details: [], type: '', creditLimitData: {} })}
                maxWidth="sm"
                fullWidth
            >
                {errorDialog.type === 'creditLimit' && errorDialog.creditLimitData ? (
                    <>
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, borderBottom: `2px solid ${themeColors.error.main}` }}>
                            <Typography fontWeight={700} color="error" fontSize={18}>
                                ⚠️ Credit Limit Exceeded
                            </Typography>
                        </DialogTitle>
                        <DialogContent sx={{ pt: 3 }}>

                            <Box sx={{
                                p: 2,
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fed7d7',
                                borderRadius: 1.5,
                                mb: 2,
                                mt: 2
                            }}>
                                <Box sx={{ mb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography fontSize={13} color="textSecondary">Credit Limit:</Typography>
                                    <Typography fontSize={14} fontWeight={600} color="error">
                                        ₹ {Number(errorDialog.creditLimitData.creditLimit || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </Box>
                                <Box sx={{ mb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography fontSize={13} color="textSecondary">Outstanding Amount:</Typography>
                                    <Typography fontSize={14} fontWeight={600} color="#d97706">
                                        ₹ {Number(errorDialog.creditLimitData.outstandingAmount || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </Box>
                                <Box sx={{ mb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography fontSize={13} color="textSecondary">Current Bill Amount:</Typography>
                                    <Typography fontSize={14} fontWeight={600} color="#0ea5e9">
                                        ₹ {Number(errorDialog.creditLimitData.currentBillAmount || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </Box>
                                <Box sx={{ pt: 1.5, borderTop: '1px dashed #fed7d7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography fontSize={14} fontWeight={700} color="error">Total Amount:</Typography>
                                    <Typography fontSize={16} fontWeight={700} color="error">
                                        ₹ {Number(errorDialog.creditLimitData.totalAmount || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box sx={{
                                p: 1.5,
                                backgroundColor: '#fee2e2',
                                border: '1px solid #fecaca',
                                borderRadius: 1,
                                mb: 2
                            }}>
                                <Typography fontSize={13} fontWeight={600} color="error" sx={{ mb: 0.5 }}>
                                    Exceed by: ₹ {Number(errorDialog.creditLimitData.exceedAmount || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                </Typography>
                                <Typography fontSize={12} color="#7f1d1d">
                                    ❌ Bill creation is BLOCKED - credit limit cannot be exceeded. Please contact management to increase credit limit.
                                </Typography>
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ p: 2, gap: 1 }}>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => {
                                    setErrorDialog({ open: false, details: [], type: '', creditLimitData: {} });
                                }}
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </>
                ) : (
                    <>
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                            <Typography fontWeight={600} color="error">Stock Quantity Exceeded</Typography>
                        </DialogTitle>
                        <DialogContent>
                            {errorDialog.details.map((item, i) => (
                                <Box
                                    key={i}
                                    sx={{
                                        mb: i < errorDialog.details.length - 1 ? 2 : 0,
                                        p: 1.5,
                                        borderRadius: 1,
                                        backgroundColor: '#fff5f5',
                                        border: '1px solid #ffcdd2'
                                    }}
                                >
                                    <Typography fontSize={13.5} fontWeight={600} color="error">
                                        {item.summary}
                                    </Typography>
                                    <Typography
                                        fontSize={13.5}
                                        color="error"
                                        sx={{
                                            mt: 0.5,
                                            opacity: 0.85,
                                            wordBreak: 'break-all',
                                            lineHeight: 1.8
                                        }}
                                    >
                                        {item.details}
                                    </Typography>
                                </Box>
                            ))}
                        </DialogContent>
                        <DialogActions sx={{ p: 2 }}>
                            <Button
                                variant="outlined"
                                onClick={() => setErrorDialog({ open: false, details: [], type: '', creditLimitData: {} })}
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>


            <Dialog
                open={advanceDialogOpen}
                onClose={() => setAdvanceDialogOpen(false)}
                fullWidth
                maxWidth={isMobile ? '100%' : 'md'}
                PaperProps={{
                    sx: {
                        borderRadius: isMobile ? 0 : 2,
                        m: isMobile ? 0 : 2,
                        // width: isMobile ? '100%' : 'auto',
                        height: isMobile ? '100dvh' : 'auto',
                        // maxHeight: isMobile ? '100dvh' : '90vh',
                        display: 'flex',
                        overflow: 'hidden'
                    }
                }}
            >

                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >

                    <Typography variant="h6">
                        Select Advance Receipts
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: "primary.main",
                            fontWeight: 600
                        }}
                    >
                        Bill Total : {Number(totals.total || 0).toFixed(2)}
                    </Typography>

                </DialogTitle>

                <DialogContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'hidden'
                }}>

                    {/* DESKTOP */}
                    {!isMobile && (

                        <Box sx={{ height: 400, width: '100%', mt: 1 }}>

                            <DataGrid
                                rows={advanceReceipts}
                                getRowId={(row) => row.ReceiptId}
                                checkboxSelection
                                disableRowSelectionOnClick
                                // onRowSelectionModelChange={handleAdvanceSelection}
                                rowSelectionModel={selectedAdvanceRows.map(r => r.ReceiptId)}
                                isRowSelectable={() => {

                                    // âŒ disable selection
                                    if (
                                        mode === "edit" &&
                                        initialData?.advanceReceipts?.length > 0
                                    ) {
                                        return false;
                                    }

                                    return true;
                                }}

                                onRowSelectionModelChange={
                                    (newSelection) => {

                                        if (
                                            mode === "edit" &&
                                            initialData?.advanceReceipts?.length > 0
                                        ) {
                                            return;
                                        }

                                        handleAdvanceSelection(newSelection);
                                    }
                                }

                                columns={[
                                    {
                                        field: 'ReceiptNumber',
                                        headerName: 'Receipt No',
                                        flex: 1
                                    },
                                    {
                                        field: 'ReceiptDate',
                                        headerName: 'Date',
                                        flex: 1
                                    },
                                    // {
                                    //     field: 'Amount',
                                    //     headerName: 'Amount',
                                    //     flex: 1
                                    // },
                                    {
                                        field: 'DisplayAdvanceAmount',
                                        headerName: 'Available Advance',
                                        flex: 1
                                    },
                                    {
                                        field: 'AdjustAmount',
                                        headerName: 'Adjust Amount',
                                        flex: 1,
                                        renderCell: (params) => {

                                            const row = params.row;

                                            const selected = selectedAdvanceRows.some(
                                                r => r.ReceiptId === row.ReceiptId
                                            );

                                            return (
                                                <TextField
                                                    size="small"
                                                    type="number"
                                                    disabled={!selected || (mode === "edit" &&
                                                        initialData?.advanceReceipts?.length > 0)}
                                                    fullWidth
                                                    value={
                                                        selectedAdvanceRows.find(
                                                            r => r.ReceiptId === row.ReceiptId
                                                        )?.AdjustAmount || ''
                                                    }
                                                    inputProps={{
                                                        min: 0,
                                                        max: row.DisplayAdvanceAmount
                                                    }}
                                                    onChange={(e) => {

                                                        const value = Number(e.target.value || 0);

                                                        if (value > Number(row.DisplayAdvanceAmount)) {
                                                            return;
                                                        }

                                                        setSelectedAdvanceRows(prev =>
                                                            prev.map(item =>
                                                                item.ReceiptId === row.ReceiptId
                                                                    ? {
                                                                        ...item,
                                                                        AdjustAmount: value,
                                                                        isManual: true
                                                                    }
                                                                    : item
                                                            )
                                                        );
                                                    }}
                                                />
                                            );
                                        }
                                    }
                                ]}
                            />

                        </Box>
                    )}

                    {/* MOBILE */}
                    {isMobile && (
                        <>
                            <Box display="flex" justifyContent="space-between">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                advanceReceipts.length > 0 &&
                                                selectedAdvanceRows.length ===
                                                advanceReceipts.length
                                            }
                                            indeterminate={
                                                selectedAdvanceRows.length > 0 &&
                                                selectedAdvanceRows.length < advanceReceipts.length
                                            }
                                            onChange={(e) => {

                                                if (e.target.checked) {

                                                    handleAdvanceSelection(
                                                        advanceReceipts.map(
                                                            r => r.ReceiptId
                                                        )
                                                    );

                                                } else {

                                                    setSelectedAdvanceRows([]);
                                                }
                                            }}
                                        />
                                    }
                                    label="Select All"

                                    disabled={mode === "edit" &&
                                        initialData?.advanceReceipts?.length > 0}
                                />
                            </Box>

                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: 'auto',
                                    p: 2,
                                    pb: 10
                                }}
                            >
                                {advanceReceipts.map((receipt) => {

                                    const isSelected =
                                        selectedAdvanceRows.some(
                                            r => r.ReceiptId === receipt.ReceiptId
                                        );

                                    const selectedRow =
                                        selectedAdvanceRows.find(
                                            r => r.ReceiptId === receipt.ReceiptId
                                        );

                                    return (

                                        <Box
                                            key={receipt.ReceiptId}
                                            sx={{
                                                border: `1px solid ${themeColors.neutral.line}`,
                                                borderRadius: 2,
                                                p: 2,
                                                mb: 2
                                            }}
                                        >

                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                            >

                                                <Checkbox
                                                    checked={isSelected}
                                                    disabled={
                                                        (!isSelected &&
                                                            totalSelectedAdvance >=
                                                            Number(totals.total || 0)) || (mode === "edit" &&
                                                                initialData?.advanceReceipts?.length > 0)
                                                    }
                                                    onChange={(e) => {

                                                        let newSelection = [];

                                                        if (e.target.checked) {

                                                            newSelection = [
                                                                ...selectedAdvanceRows.map(
                                                                    r => r.ReceiptId
                                                                ),
                                                                receipt.ReceiptId
                                                            ];

                                                        } else {

                                                            newSelection =
                                                                selectedAdvanceRows
                                                                    .filter(
                                                                        r =>
                                                                            r.ReceiptId !==
                                                                            receipt.ReceiptId
                                                                    )
                                                                    .map(r => r.ReceiptId);
                                                        }

                                                        handleAdvanceSelection(
                                                            newSelection
                                                        );
                                                    }}
                                                />

                                                <Typography fontWeight={600}>
                                                    {receipt.ReceiptNo}
                                                </Typography>
                                            </Box>

                                            <Typography variant="body2">
                                                Date :
                                                {
                                                    receipt.Date
                                                        ? new Date(receipt.Date)
                                                            .toLocaleDateString("en-GB")
                                                        : receipt.ReceiptDate
                                                            ? new Date(receipt.ReceiptDate)
                                                                .toLocaleDateString("en-GB")
                                                            : "-"
                                                }
                                            </Typography>

                                            <Typography variant="body2">
                                                Available :
                                                ₹{receipt.DisplayAdvanceAmount}
                                            </Typography>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="number"
                                                label="Adjust Amount"
                                                sx={{ mt: 1.5 }}
                                                disabled={!isSelected || (mode === "edit" &&
                                                    initialData?.advanceReceipts?.length > 0)}
                                                value={
                                                    selectedRow?.AdjustAmount || ""
                                                }
                                                onChange={(e) => {

                                                    const value =
                                                        Number(e.target.value || 0);

                                                    setSelectedAdvanceRows(prev =>
                                                        prev.map(r => {

                                                            if (
                                                                r.ReceiptId !==
                                                                receipt.ReceiptId
                                                            ) {
                                                                return r;
                                                            }

                                                            return {
                                                                ...r,
                                                                AdjustAmount: value,
                                                                isManual: true
                                                            };
                                                        })
                                                    );
                                                }}
                                            />
                                        </Box>
                                    );
                                })}
                            </Box>


                        </>
                    )}

                    <Box
                        display="flex"
                        justifyContent="flex-end"
                        gap={1}
                        mt={2}
                    >


                        <Box
                            display="flex"
                            flexDirection={isMobile ? "column" : "row"}
                            justifyContent="space-between"
                            alignItems="center"
                            mt={isMobile ? 0 : 2}
                            sx={{ width: "100%" }}
                        >

                            <Box>
                                <Typography
                                    fontWeight={500}
                                >
                                    Remaining :
                                    {formatINR(
                                        Number(totals.total || 0) -
                                        totalSelectedAdvance
                                    )}
                                </Typography>
                            </Box>


                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                flexWrap="wrap"
                            >
                                <Typography fontWeight={600}>
                                    Selected Advance :
                                    {formatINR(totalSelectedAdvance)}
                                </Typography>
                            </Box>

                            <Box display="flex" gap={1}>

                                <Button
                                    onClick={() => setAdvanceDialogOpen(false)}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    variant="contained"
                                    disabled={mode === "edit" &&
                                        initialData?.advanceReceipts?.length > 0}
                                    onClick={() => {

                                        if (totalSelectedAdvance > Number(totals.total || 0)) {

                                            setSnackbar({
                                                open: true,
                                                severity: "error",
                                                message:
                                                    "Selected advance amount cannot exceed invoice total"
                                            });

                                            return;
                                        }

                                        setAdvanceDialogOpen(false);
                                    }}
                                >
                                    Done
                                </Button>

                            </Box>

                        </Box>
                    </Box>

                </DialogContent>

            </Dialog>


            <Dialog
                open={confirmAdvanceResetOpen}
                onClose={cancelAdvanceReset}
            >
                <DialogTitle>
                    Remove Advance Adjustment?
                </DialogTitle>

                <DialogContent>

                    <Typography>
                        Unchecking this will reset all adjusted advance receipts.Are you sure you want to continue?
                    </Typography>

                    <Box
                        mt={2}
                        display="flex"
                        justifyContent="flex-end"
                        gap={1}
                    >
                        <Button
                            onClick={cancelAdvanceReset}
                            variant="outlined"
                        >
                            Cancel
                        </Button>

                        <Button
                            onClick={confirmAdvanceReset}
                            color="error"
                            variant="contained"
                        >
                            Reset
                        </Button>
                    </Box>

                </DialogContent>
            </Dialog>

            <Dialog
                open={stockWarningOpen}
                onClose={() => {
                    setStockWarningOpen(false);
                    if (stockConfirmResolve) stockConfirmResolve(false);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    ⚠️ Stock Warning
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ color: themeColors.error.dark, fontSize: '16px', lineHeight: 1.6 }}>
                        {stockWarningData?.message}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(false);
                        }}
                        sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(true);
                        }}
                        sx={{ bgcolor: themeColors.error.dark, '&:hover': { bgcolor: themeColors.error.darker } }}
                    >
                        Yes, Save Anyway
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={zeroStockErrorOpen}
                onClose={() => {
                    setZeroStockErrorOpen(false);
                    if (stockConfirmResolve) stockConfirmResolve(false);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    {zeroStockErrorData?.isBlocked ? '❌ Cannot Add Product' : '⚠️ Zero/Negative Stock Warning'}
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ color: themeColors.error.dark, fontSize: '16px', lineHeight: 1.6 }}>
                        {zeroStockErrorData?.message}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    {zeroStockErrorData?.isBlocked ? (
                        // Hard block (configuration disallows adding this item) — only acknowledge and close.
                        <Button
                            variant="contained"
                            onClick={() => {
                                setZeroStockErrorOpen(false);
                                if (stockConfirmResolve) stockConfirmResolve(false);
                            }}
                            sx={{ bgcolor: themeColors.error.dark, '&:hover': { bgcolor: themeColors.error.darker } }}
                        >
                            OK
                        </Button>
                    ) : (
                        <>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    setZeroStockErrorOpen(false);
                                    if (stockConfirmResolve) stockConfirmResolve(false);
                                }}
                                sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setZeroStockErrorOpen(false);
                                    if (stockConfirmResolve) stockConfirmResolve(true);
                                }}
                                sx={{ bgcolor: themeColors.error.dark, '&:hover': { bgcolor: themeColors.error.darker } }}
                            >
                                Yes, Add Anyway
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>

            {/* "Enable Convesrion effect in Transaction?" — Conversion Qty popup, shown when Unit is
                changed away from the product's default Unit. */}
            <Dialog
                open={conversionQtyDialogOpen}
                onClose={handleCancelConversionQty}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    Unit Conversion
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ fontSize: '14px', color: themeColors.neutral.sub, mb: 2 }}>
                        How many {pendingUnitChange?.unit || 'unit'} make 1 {current.unit || 'base unit'}?
                    </Typography>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Conversion Qty"
                        size="small"
                        type="text"
                        value={conversionQtyInput}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val === '' || /^\d*\.?\d{0,4}$/.test(val)) setConversionQtyInput(val);
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={handleCancelConversionQty}
                        sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmConversionQty}
                        sx={{ bgcolor: colors.primary.main, '&:hover': { bgcolor: '#0d5dc7' } }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </Paper>
    );
};

export default ProductDetails;
